export default {
  "account-candidate-content": "기술 평가에 응시하고\n기술 역량을 증명하세요.",
  "account-organization-title": "조직",
  "account-organization-content": "응시자의 기술 역량을 평가하고\n데이터 기반 의사결정을 내리세요.",
  "sign-up-top-title": "코드프레소 계정 생성",
  "account-login": "로그인",
  "account-signup": "회원가입",
  "account-email": "이메일",
  "account-password": "비밀번호",
  "social-title": "또는",
  "social-linkedin": "LinkedIn",
  "social-google": "Google",
  "sign-up-term-content": "코드프레소의 {policy} 및 {term}에 동의하며 본인이 16세 이상임을 확인합니다.",
  "common-terms-of-use": "이용약관",
  "common-legal-notice": "법적 고지",
  "common-privacy-policy": "개인정보처리방침",
  "common-cookie-policy": "쿠키 정책",
  "sign-up-bottom": "이미 계정이 있으신가요?",
  "error-null-email": "이메일을 입력해야 합니다.",
  "error-personal-email": "개인 이메일 또는 임시 이메일은 허용되지 않습니다.\n업무 이메일을 입력해주세요.",
  "error-signup-blocked": "입력하신 이메일로 회원가입을 진행할 수 없습니다.\n다시 시도해보시고 문제가 지속되는 경우, support@codepresso.io로 문의해주세요.",
  "error-null-password": "비밀번호는 10자 이상으로 입력해야 합니다.",
  "error-sign-wrong-approach": "오류로 인해 요청된 작업을 수행할 수 없습니다.\n다시 시도해주세요.",
  "error-invalid-email": "이메일이 올바른지 확인해주세요.",
  "error-invalid-password-size": "비밀번호는 10자 이상이어야 합니다.",
  "error-invalid-password": "비밀번호는 숫자, 영문 대소문자를 모두 포함해야 합니다.",
  "sign-send-verification-email": "인증 메일이 발송되었습니다.",
  "sign-verify-email-title": "코드프레소를 시작하려면\n이메일을 인증해주세요",
  "sign-verify-email-content": "'{email}' 이메일로 발송된 메일을 확인하고 인증을 진행해주세요. 인증 메일을 받지 못한 경우, 아래 버튼을 클릭하여 재발송할 수 있습니다.",
  "sign-verify-email-resend": "인증 메일 재발송",
  "sign-resend-verification-email": "인증 메일이 재발송되었습니다.",
  "sign-send-verification-email-delay": "30초 후에 인증 메일을 다시 발송할 수 있습니다.",
  "sign-up-complete-title": "모든 준비가 완료되었습니다",
  "sign-up-complete-content": "'{email}' 계정의 이메일 인증이 완료되었으며 지금부터 코드프레소를 이용하실 수 있습니다.",
  "common-start": "시작",
  "sign-up-fail-title": "인증 메일을 재발송해주세요",
  "sign-up-fail-description": "인증 링크가 만료되어 이메일 인증을 할 수 없습니다.",
  "sign-up-error-title": "기술적인 오류로 인해 이메일을 확인할 수 없습니다",
  "sign-up-error-content": "메일에 있는 버튼을 클릭하여 다시 시도해주세요.",
  "sign-in-top-title": "계정 로그인",
  "sign-in-bottom": "계정이 없으신가요?",
  "account-find-password": "비밀번호를 잊어버렸습니다.",
  "error-account-mis-match": "이메일과 비밀번호를 다시 확인해주세요.",
  "error-used-email": "이미 사용 중인 이메일입니다.",
  "account-required": "로그인이 필요합니다.",
  "account-up-required": "회원가입이 필요합니다.",
  "password-change-enter-email": "이메일을 입력해주세요",
  "password-change-send-mail-content": "비밀번호 재설정을 위한 메일이 발송됩니다.",
  "password-change-send-mail": "메일 발송",
  "password-change-send-success-dot": "비밀번호 재설정 메일이 발송되었습니다.",
  "password-change-send-success": "비밀번호 재설정 메일이 발송되었습니다",
  "password-change-resend-mail-content-1": "'{email}' 이메일로 발송된 메일을 확인하고 비밀번호 재설정을 진행해주세요.",
  "password-change-resend-mail-content-2": "비밀번호 재설정 메일을 받지 못한 경우, 아래 버튼을 클릭하여 재발송할 수 있습니다.",
  "password-change-resend-email": "비밀번호 재설정 메일 재발송",
  "password-change-resend-success": "비밀번호 재설정 메일이 재발송되었습니다.",
  "password-change-resend-delay": "30초 후에 비밀번호 재설정 메일을 다시 발송할 수 있습니다.",
  "password-change-title": "새 비밀번호를 설정해주세요",
  "password-change-content": "'{email}' 계정의 새 비밀번호를 아래에 입력해주세요.",
  "password-change-new-password": "새 비밀번호",
  "password-change-confirm-new-password": "새 비밀번호 확인",
  "password-change": "비밀번호 변경",
  "error-null-new-password": "새 비밀번호를 입력해야 합니다.",
  "error-null-confirm-new-password": "새 비밀번호와 새 비밀번호 확인이 일치하는지 확인해주세요.",
  "error-save-new-password": "오류가 발생하여 새 비밀번호를 저장할 수 없습니다.",
  "password-change-success": "비밀번호 변경이 완료되었습니다",
  "password-change-continue": "'{email}' 계정의 비밀번호가 변경되었습니다.\n계속하려면 계정에 로그인해주세요.",
  "password-change-login-account": "내 계정에 로그인",
  "password-change-fail": "비밀번호 재설정 메일을 재발송해주세요",
  "password-change-fail-description": "비밀번호 재설정 링크가 만료되어 비밀번호 재설정을 진행할 수 없습니다.",
  "register-description": "안녕하세요, {nickName}님!\n회원가입을 완료해주세요",
  "register-country-select": "국가/지역을 선택해주세요.",
  "register-country-region": "국가/지역 검색",
  "common-none-search-data": "검색 결과가 없습니다.",
  "common-next": "다음",
  "register-notifications-main-content": "최신 컨텐츠, 이벤트, 뉴스, 기능, 챌린지 등 코드프레소의 소식을 받아보고 싶으십니까?",
  "register-notifications-sub-content-1": "코드프레소의 소식을 이메일로 받고 싶습니다.",
  "common-first-name": "이름",
  "common-placeholder-first-name": "이름을 입력해주세요.",
  "error-first-name": "이름은 1~25자 사이여야 합니다.",
  "error-invalid-first-name": "이름이 올바른지 확인해주세요.",
  "common-last-name": "성",
  "common-placeholder-last-name": "성을 입력해주세요.",
  "error-last-name": "성은 1~25자 사이여야 합니다.",
  "error-invalid-last-name": "성이 올바른지 확인해주세요.",
  "organization-create-title": "이어서 조직 생성 여부를 선택해주세요",
  "organization-create-option-1": "조직 생성",
  "organization-create-option-2": "조직 생성 안 함",
  "organization-create-description": "조직을 생성하면 {username}님에게 조직 최고 관리자 권한이 부여되며 조직 운영을 시작할 수 있습니다.",
  "common-organization-name": "조직명",
  "common-placeholder-organization-name": "조직명을 입력해주세요.",
  "error-organization-name": "조직명은 1~50자 사이여야 합니다.",
  "register-organization-size-title": "조직 규모",
  "register-organization-size-select": "조직 규모를 선택해주세요.",
  "settings-title": "설정",
  "settings-logout": "로그아웃",
  "account-username": "사용자 이름",
  "account-organization": "조직",
  "account-none-organization": "어떤 조직에도 소속되어 있지 않습니다",
  "account-country": "국가/지역",
  "common-save": "저장",
  "account-change-success": "계정 변경 사항이 저장되었습니다.",
  "account-change-fail": "계정 변경 사항을 저장할 수 없습니다.\n다시 시도해주세요.",
  "account-valid-name-size": "사용자 이름은 2~25자 사이여야 합니다.",
  "settings-account": "계정",
  "settings-notifications": "알림",
  "account-delete": "계정 삭제",
  "account-my-delete": "내 계정 삭제",
  "account-delete-agree-title": "계정을 삭제하기 전에 동의해주세요",
  "account-delete-agree-description": "개인 식별이 가능한 정보는 영구적으로 삭제되고 비식별화된 일부 정보는 통계 목적으로 보관될 수 있습니다.\n자세한 내용은 {linkDom}을 확인해주세요.",
  "account-delete-agree-info": "개인 식별이 가능한 정보는 영구적으로 삭제되고 비식별화된 일부 정보는 통계 목적으로 보관될 수 있음을 동의합니다.",
  "account-delete-success": "계정이 삭제되었습니다.",
  "account-delete-fail": "계정을 삭제할 수 없습니다.\n다시 시도해주세요.",
  "account-current-password": "현재 비밀번호",
  "error-current-password": "현재 비밀번호를 입력해야 합니다.",
  "error-password-incorrect": "현재 비밀번호가 올바른지 확인해주세요.",
  "password-saving-success": "비밀번호가 변경되었습니다.",
  "password-saving-fail": "비밀번호 변경 사항을 저장할 수 없습니다.\n다시 시도해주세요.",
  "notifications-agree-title": "코드프레소 소식 받기",
  "notifications-agree-content": "최신 컨텐츠, 이벤트, 뉴스, 기능, 챌린지 등 코드프레소의 모든 소식을 받아볼 수 있습니다.",
  "notifications-change-success": "알림 변경 사항이 저장되었습니다.",
  "notifications-change-fail": "알림 변경 사항을 저장할 수 없습니다. \n다시 시도해주세요.",
  "organization-members-management": "조직 사용자 관리",
  "account-delete-transfer-of-role-info": "계정 삭제 전 조직 최고 관리자 권한을 다른 조직 사용자에게 이전해주세요.",
  "account-delete-info": "구독 종료 후 계정 삭제를 진행할 수 있습니다.",
  "organization-settings-title": "조직 설정",
  "organization-create-button": "생성",
  "organization-create-success": "조직이 생성되었습니다.",
  "organization-create-fail": "조직을 생성할 수 없습니다.\n다시 시도해주세요.",
  "organization-leave": "조직 탈퇴",
  "organization-my-leave": "내 조직 탈퇴",
  "organization-leave-transfer-of-role-info": "조직 탈퇴 전 조직 최고 관리자 권한을 다른 조직 사용자에게 이전해주세요.",
  "organization-leave-info": "구독 종료 후 조직 탈퇴를 진행할 수 있습니다.",
  "organization-leave-title": "조직을 탈퇴하시겠습니까?",
  "organization-leave-info-1": "더 이상 {OrganizationName} 조직과 관련된 기능을 이용할 수 없습니다.",
  "organization-leave-info-2-prefix": "",
  "organization-leave-info-2-suffix": "를 입력하면 [탈퇴] 버튼이 활성화됩니다.",
  "organization-leave-button": "탈퇴",
  "organization-leave-success": "조직 탈퇴가 성공적으로 완료되었습니다.",
  "organization-leave-fail": "조직 탈퇴를 완료할 수 없습니다.\n다시 시도해주세요.",
  "organization-change-success": "조직 변경 사항이 저장되었습니다.",
  "organization-change-fail": "조직 변경 사항을 저장할 수 없습니다.\n다시 시도해주세요.",
  "organization-Invite-members": "사용자 초대",
  "organization-Invite-members-description": "입력하신 이메일로 초대 메일이 발송됩니다.",
  "organization-menu-access": "메뉴 접근",
  "organization-role": "역할",
  "organization-role-select": "역할을 선택해주세요.",
  "organization-role-administrator": "관리자",
  "organization-role-administrator-description": "메뉴 접근 권한이 부여된 기능을 이용할 수 있으며 조직 정보를 확인할 수 있습니다.",
  "organization-member-remove-title": "사용자를 제거하시겠습니까?",
  "organization-member-remove-success": "사용자가 성공적으로 제거되었습니다.",
  "organization-member-add": "사용자 추가",
  "organization-member-add-success": "사용자가 추가되었습니다.",
  "organization-Invite-members-success": "{Count}명의 사용자에게 초대 메일이 발송되었습니다.",
  "organization-Invite-members-fail": "{Count}명의 사용자를 초대할 수 없습니다.\n다시 시도해주세요.",
  "organization-Invite-members-email-error-1": "이미 조직에 소속된 이메일입니다.",
  "organization-Invite-members-email-error-2": "이미 초대된 이메일입니다.",
  "organization-Invite-members-email-error-3": "중복 입력된 이메일입니다.",
  "organization-Invite-members-menu-access-error": "최소 1개 이상의 메뉴를 선택해야 합니다.",
  "organization-member-count": "명의 사용자",
  "organization-member": "사용자",
  "organization-role-chief-administrator": "최고 관리자",
  "organization-invited": "초대됨",
  "organization-active": "활성",
  "organization-last-accessed-date": "최근 접속일",
  "organization-transfer-of-role-button-1": "조직 최고 관리자 권한 이전",
  "organization-member-edit": "사용자 수정",
  "organization-member-delete": "사용자 삭제",
  "organization-member-resend-email-description": "'{email}'님에게 초대 메일을 다시 보내시겠습니까?",
  "organization-member-resend-email-success": "'{email}'님에게 초대 메일이 재발송되었습니다.",
  "organization-member-resend-email-fail": "'{email}'님에게 초대 메일을 재발송할 수 없습니다.\n다시 시도해주세요.",
  "organization-transfer-of-role-title": "조직 최고 관리자 권한을 이전하기 전에 동의해주세요",
  "organization-transfer-of-role-description": "권한을 이전하면 조직 관리자가 되며 더 이상 조직 정보를 수정할 수 없습니다.",
  "organization-transfer-of-role-info": "조직 최고 관리자 권한 이전에 동의합니다.",
  "organization-transfer-of-role-button-2": "권한 이전",
  "organization-transfer-of-role-success": "조직 최고 관리자 권한이 이전되었습니다.",
  "organization-transfer-of-role-fail": "조직 최고 관리자 권한을 이전할 수 없습니다.\n다시 시도해주세요.",
  "organization-member-information": "사용자 정보",
  "organization-member-information-success": "사용자 정보가 저장되었습니다.",
  "organization-member-information-fail": "사용자 정보를 저장할 수 없습니다.\n다시 시도해주세요.",
  "organization-member-delete-title": "사용자를 삭제하시겠습니까?",
  "organization-member-delete-success": "사용자가 성공적으로 삭제되었습니다.",
  "organization-member-delete-fail": "사용자를 삭제할 수 없습니다.\n다시 시도해주세요.",
  "organization-invite-accept-fail": "{OrganizationName}에\n합류할 수 없습니다",
  "organization-invite-accept-fail-content": "다른 조직에 소속되어 있거나 문제가 발생하여 초대를 수락할 수 없습니다.\n기존 조직에서 탈퇴한 후 다시 시도하시거나 관리자에게 새로운 초대 메일을 요청해주세요.",
  "organization-invite-accept-success": "{OrganizationName}에\n합류되었습니다",
  "organization-invite-accept-success-content": "지금부터 {OrganizationName} 조직과 관련된 기능을 이용할 수 있습니다.",
  "organization-Invite-members-restriction-info": "사용자 초대 기능은 프로, 엔터프라이즈 플랜에서 사용할 수 있습니다.",
  "organization-subscription-management": "구독 관리",
  "organization-subscription-none-description-1": "아직 구독 중인 플랜이 없습니다.",
  "organization-subscription-none-description-2": "서비스를 이용하려면 구독을 시작해주세요.",
  "organization-subscription-none-button": "플랜 보기",
  "organization-subscription-label-1": "구독중",
  "organization-subscription-label-2": "결제 필요",
  "organization-subscription-label-3": "구독 해지 예정",
  "organization-subscription-label-4": "구독 종료",
  "organization-subscription-manage": "관리",
  "organization-subscription-change-billing-cycle": "결제 주기 변경",
  "organization-subscription-change-payment-method": "결제 수단 변경",
  "organization-subscription-coupon-management": "쿠폰 관리",
  "organization-subscription-cancel-subscription": "구독 해지",
  "organization-subscription-change-billing-cycle-title": "결제 주기를 변경하시겠습니까?",
  "organization-subscription-change-billing-cycle-description-1": "변경 후",
  "organization-subscription-change-billing-cycle-description-2": "다음 결제부터 적용됩니다.",
  "organization-subscription-change-billing-cycle-button": "변경",
  "organization-subscription-change-billing-cycle-success": "결제 주기 변경이 완료되었습니다.\n다음 결제부터 적용됩니다.",
  "organization-subscription-change-billing-cycle-fail": "결제 주기 변경을 완료할 수 없습니다.\n다시 시도해주세요.",
  "organization-subscription-change-billing-cycle-scheduled-1": "다음 결제부터 월간 주기로 변경 예정",
  "organization-subscription-change-billing-cycle-scheduled-2": "다음 결제부터 연간 주기로 변경 예정",
  "organization-subscription-cancel-change": "변경 취소",
  "organization-subscription-applied": "적용됨",
  "organization-subscription-cancel-apply": "적용 취소",
  "organization-subscription-change-payment-method-success": "결제 수단 변경이 완료되었습니다.",
  "organization-subscription-cancel-subscription-title": "구독을 해지하시겠습니까?",
  "organization-subscription-cancel-subscription-description-1": "해지 후에도 {date}까지 서비스를 계속 이용할 수 있습니다.",
  "organization-subscription-cancel-subscription-description-3": "신규 평가 생성 및 응시자 초대가 제한됩니다.",
  "organization-subscription-cancel-subscription-description-4": "기존 평가 및 데이터는 유지됩니다.",
  "organization-subscription-cancel-subscription-description-5": "최고 관리자 외 관리자 계정은 조직 기능을 이용할 수 없습니다.",
  "organization-subscription-cancel-subscription-success": "구독 해지가 완료되었습니다.",
  "organization-subscription-cancel-subscription-fail": "구독 해지를 완료할 수 없습니다.\n다시 시도해주세요.",
  "organization-subscription-payment-failed": "결제 실패",
  "organization-subscription-payment-failed-description-1": "{date}까지 결제가 완료되지 않으면 이용이 제한됩니다.",
  "organization-subscription-payment-failed-description-2": "자동 결제 재시도 진행중",
  "organization-subscription-retry-payment": "결제 재시도",
  "organization-subscription-retry-payment-title": "결제를 재시도하시겠습니까?",
  "organization-subscription-retry-payment-description": "등록된 결제 수단으로 결제가 즉시 진행됩니다.",
  "organization-subscription-retry-payment-success": "결제가 완료되었습니다.",
  "organization-subscription-retry-payment-fail": "결제를 완료할 수 없습니다.\n다시 시도해주세요.",
  "payment-complete-next-billing-attempt-date": "다음 결제 시도일",
  "organization-subscription-change-billing-cycle-scheduled-3": "다음 결제 시도부터 월간 주기로 변경 예정",
  "organization-subscription-change-billing-cycle-scheduled-4": "다음 결제 시도부터 연간 주기로 변경 예정",
  "organization-subscription-cancellation-pending-description": "{date}까지 이용 가능하며,\n이후 자동으로 종료되어 요금이 청구되지 않습니다.",
  "organization-subscription-cancel-cancellation-request": "해지 요청 취소",
  "organization-subscription-cancel-cancellation-request-success": "해지 요청 취소가 완료되었습니다.",
  "organization-subscription-cancel-cancellation-request-fail": "해지 요청 취소를 완료할 수 없습니다.\n다시 시도해주세요.",
  "organization-subscription-restart-subscription": "구독 재시작",
  "organization-subscription-restart-subscription-title": "구독을 재시작하시겠습니까?",
  "organization-subscription-restart-subscription-description-1": "재시작할 플랜",
  "organization-subscription-restart-subscription-description-2": "구독을 재시작하면 요금이 청구되며\n서비스를 다시 이용할 수 있습니다.",
  "organization-subscription-restart-subscription-success": "구독이 재시작되었습니다.",
  "organization-subscription-restart-subscription-fail": "구독을 재시작할 수 없습니다.\n다시 시도해주세요.",
  "organization-subscription-end-subscription-description": "구독 재시작 시",
  "organization-subscription-change-billing-cycle-scheduled-5": "구독 재시작 시 월간 주기로 변경 예정",
  "organization-subscription-change-billing-cycle-scheduled-6": "구독 재시작 시 연간 주기로 변경 예정",
  "organization-subscription-contract-information": "계약 정보",
  "organization-subscription-contract-end-date": "계약 종료일",
  "organization-subscription-contract-end-date-description": "계약 종료일 이후 조직 최고 관리자를 제외한 조직 관리자 권한은 제거됩니다.",
  "organization-subscription-payment-method": "결제 방식",
  "organization-subscription-subject-to-contract": "계약에 따름",
  "organization-subscription-renewal-method": "갱신 방식",
  "organization-subscription-negotiation": "협의",
  "organization-subscription-contract-end": "계약 종료",
  "organization-subscription-contract-end-description-1": "계약이 종료되었습니다.",
  "organization-subscription-contract-end-description-2": "서비스를 계속 이용하려면 문의해주세요.",
  "organization-subscription-coupon-management-tab-menu-1": "사용 가능",
  "organization-subscription-coupon-management-tab-menu-2": "사용 완료",
  "organization-subscription-coupon-management-tab-menu-3": "기간 만료",
  "organization-subscription-coupon-management-count": "00개의 쿠폰",
  "organization-subscription-coupon-management-apply-coupon": "쿠폰 적용",
  "organization-subscription-coupon-management-none-1": "아직 사용 가능한 쿠폰이 없습니다.",
  "organization-subscription-coupon-management-none-2": "아직 사용 완료 또는 기간 만료된 쿠폰이 없습니다.",
  "organization-subscription-payment-history-count": "건의 결제",
  "organization-subscription-payment-history-item": "항목",
  "organization-subscription-payment-history-invoice": "청구서",
  "organization-subscription-payment-history-none": "아직 결제 내역이 없습니다.",
  "organization-subscription-payment-history-canceled-date": "환불 처리일",
  "organization-subscription-payment-history-fully-canceled": "전액 취소",
  "organization-subscription-payment-history-partially-canceled": "부분 취소",
  "credit-title": "잔여 평가 초대 크레딧:",
  "common-contact-us": "문의하기",
  "credit-banner": "평가 초대 크레딧",
  "credit-detail-button": "자세히 보기",
  "credit-management": "크레딧 관리",
  "credit-history-title": "평가 초대 크레딧 처리 내역",
  "credit-history-count": "건의 처리 내역",
  "credit-history-transaction": "처리 내역",
  "credit-history-granted": "지급",
  "credit-history-used": "사용",
  "credit-history-cancelled": "취소",
  "credit-history-revoked": "회수",
  "credit-history-table-amount": "변동",
  "credit-history-table-remaining": "잔여",
  "credit-history-table-related": "관련된",
  "credit-history-table-performed-by": "처리자",
  "credit-history-table-date": "일시",
  "credit-history-table-credit-expiration": "크레딧 유효기간",
  "credit-history-table-revoked-reason-credit-expiration": "크레딧 유효기간 만료로 자동 회수",
  "credit-history-table-until": "{time}까지",
  "credit-history-table-revoked-reason-credit-refund": "환불로 인한 회수",
  "credit-history-table-usage-details": "사용 상세",
  "credit-history-table-cancellation-details": "취소 상세",
  "credit-history-table-usage-details-info": "총 {count}개 사용",
  "credit-history-table-cancellation-details-info": "총 {count}개 취소",
  "credit-history-table-candidate-credit-count": "응시자 {candidateCount}명",
  "credit-history-table-candidate-credit-count-1": "1명당 {creditCount}개",
  "credit-history-table-none-data": "아직 평가 초대 크레딧 처리 내역이 없습니다.",
  "credit-limit-description": "평가 초대 크레딧이 필요한 경우, {linkDom} 메뉴를 통해 문의해주세요.",
  "credit-certify-invitation-button": "크레딧 설명 보기",
  "credit-certify-invitation-limit": "평가 초대 크레딧이 부족하여\n응시자를 초대할 수 없습니다",
  "credit-history-table-none-related": "삭제된 평가",
  "credit-history-top-up-credits": "크레딧 충전",
  "credit-history-top-up-credits-count": "충전할 크레딧 수",
  "credit-history-top-up-credits-count-error": "크레딧 수는 1~9,999 사이여야 합니다.",
  "credit-history-top-up-credits-description-1": "충전한 크레딧은 유효기간이 없으며, 구독 종료 후에도 사라지지 않습니다.\n단, 구독 중인 상태에서만 사용할 수 있습니다.",
  "credit-history-top-up-credits-description-2": "{link}에 등록된 결제 수단으로 결제가 진행됩니다.",
  "credit-history-top-up-credits-agree-check": "결제·크레딧 사용 조건 및 {term} 동의",
  "credit-history-top-up-credits-make-payment": "결제하기",
  "credit-history-top-up-credits-success": "크레딧 충전이 완료되었습니다.",
  "credit-history-top-up-credits-fail": "크레딧 충전을 완료할 수 없습니다.\n다시 시도해주세요.",
  "credit-history-top-up-credits-restriction-info-1-title": "구독 중인 플랜이 없어\n크레딧을 충전할 수 없습니다",
  "credit-history-top-up-credits-restriction-info-2-title": "구독이 종료되어\n크레딧을 충전할 수 없습니다",
  "credit-history-top-up-credits-restriction-info-2-description": "서비스를 계속 이용하려면 구독을 재시작해주세요.",
  "credit-history-top-up-credits-restriction-info-3-title": "엔터프라이즈 플랜은\n크레딧을 충전할 수 없습니다",
  "loading": "로딩중입니다",
  "loading-title": "잠시만 기다려주세요.",
  "404-title": "페이지를 찾을 수 없습니다",
  "404-content": "요청하신 페이지를 찾을 수 없습니다. \n입력하신 주소가 정확한지 확인 후 다시 시도해주세요.",
  "error-button": "홈으로 이동",
  "500-title": "내부 서버 오류가 발생했습니다",
  "500-content": "서버가 요청된 작업을 수행할 수 없습니다.\n잠시 후 다시 시도해주세요.",
  "400-title": "서비스 점검 중입니다",
  "400-content": "불편을 끼쳐 드려 죄송합니다.\n현재 서비스 안정화 및 업데이트 작업이 진행 중입니다. \n빠른 시간 내에 정상적인 서비스 이용이 가능하도록 하겠습니다.",
  "dashboard-back-button": "대시보드로 이동",
  "common-wrong-approach-title": "문제가 발생했습니다",
  "common-wrong-approach-content": "잠시 후 다시 시도해주세요.",
  "common-ok": "확인",
  "learning-no-access-course": "코스에 대한 접근 권한이 없습니다",
  "learning-no-access-course-description": "코스를 진행하려면 먼저 코스를 등록해야 합니다.",
  "learning-no-access-course-confirm": "트랙으로 이동",
  "learning-exercise-refresh-page": "페이지를 새로고침해주세요",
  "learning-exercise-request-fail": "기술적인 오류로 인해 작업을 수행할 수 없습니다.\n페이지를 다시 새로고침해보시고 문제가 지속되는 경우, {email}로 문의해주세요.",
  "learning-finished-course": "코스를 완료했습니다",
  "learning-finished-course-description": "트랙으로 돌아가서 학습 결과를 확인할 수 있습니다.",
  "learning-back-to-track": "트랙으로 이동",
  "learning-exercise": "연습문제",
  "common-hour": "시간",
  "common-min": "분",
  "common-s": "초",
  "common-points": "포인트",
  "learning-easy": "하",
  "learning-medium": "중",
  "learning-hard": "상",
  "learning-view-progress": "진행 상황 보기",
  "learning-go": "이동",
  "learning-course-outline": "코스 목차",
  "common-description": "설명",
  "learning-out-put": "실행 결과",
  "learning-out-put-none-submit": "실행 결과가 없더라도 제출할 수 있습니다.\n채점은 작성한 코드로 진행됩니다.",
  "learning-correct-answer": "정답",
  "learning-preview": "미리보기",
  "common-course": "코스",
  "learning-skill-count": "{count}개의 스킬",
  "learning-exercise-count": "{count}개의 연습문제",
  "common-skill": "스킬",
  "learning-none-description": "제공된 설명이 없습니다.",
  "learning-out-put-info": "코드 실행 결과입니다.",
  "learning-error-info": "코드에서 오류를 발견했습니다.",
  "learning-error-description": "오류 설명",
  "learning-submit-answer": "답안 제출",
  "learning-submit-answer-info": "문제의 답안을 제출합니다.",
  "learning-exercise-finished": "연습문제를 완료했습니다.",
  "learning-exercise-output-description": "해설 보기",
  "learning-output-description": "해설",
  "learning-exercise-complete-fail": "연습문제를 완료할 수 없습니다. \n제출한 코드를 다시 확인해주세요.",
  "learning-hint-widget-click": "힌트를 얻으려면 여기를 클릭해주세요.",
  "learning-exercise-incorrect-answer": "정답이 아닙니다.",
  "learning-correct": "정답",
  "learning-activity-widget-drop-code-here": "여기에 올바른 코드를 넣어주세요.",
  "learning-activity-widget-correct-code-herer": "여기에 올바른 코드를 넣어주세요.",
  "learning-activity-widget-drag-and-drop-code": "올바른 코드를 드래그 앤 드롭하여 빈칸을 채워주세요.",
  "learning-activity-widget-click-code": "올바른 코드를 클릭하여 빈칸을 채워주세요.",
  "learning-activity-widget-drag-and-drop-parts": "코드들을 드래그 앤 드롭하여 올바른 순서로 배치해주세요.",
  "learning-activity-widget-click-parts": "코드들을 클릭하여 올바른 순서로 배치해주세요.",
  "learning-chart": "그래프",
  "learning-lnstruction": "지침",
  "learning-multiple-choice": "객관식",
  "learning-short-answer-type": "단답형",
  "learning-essay-type": "서술형",
  "learning-answer-placeholder": "답안을 작성해주세요.",
  "learning-show-correct-answer": "정답 확인",
  "learning-answer": "답안",
  "learning-annotation-widget-1": "여기에 코드를 작성하세요",
  "learning-annotation-widget-2": "채점을 위해 아래 코드를 수정하지 마세요",
  "learning-annotation-widget-3": "제공 데이터",
  "learning-annotation-widget-4": "빈칸을 적절한 코드로 채우세요",
  "learning-annotation-widget-5": "주어진 요구사항을 충족하도록 코드를 리팩토링하세요",
  "term-copyright": "ⓒ {year} Codepresso, Inc. All rights reserved. 무단 복제 및 배포를 금지합니다.",
  "learning-directory-select-files": "Directory에서 파일을 선택해주세요.",
  "learning-reset-select-files": "초기화할 파일을 선택해주세요",
  "common-reset": "초기화",
  "learning-reset-select-files-success": "선택한 파일이 초기화되었습니다.",
  "learning-reset-select-files-fail": "선택한 파일을 초기화할 수 없습니다.\n다시 시도해주세요.",
  "learning-open-directory": "Directory 열기",
  "learning-close-directory": "Directory 닫기",
  "learning-my-output": "내 실행 결과",
  "learning-correct-output": "정답 실행 결과",
  "learning-front-exercise-delay": "사용자 PC 환경에 따라 미리보기를 확인하는 데 다소 시간이 소요될 수 있습니다.",
  "learning-front-exercise-download-fail": "실습에 필요한 설치 파일 다운로드에 실패했습니다.\n페이지를 다시 새로고침해보시고 문제가 지속되는 경우, support@codepresso.io로 문의해주세요.",
  "learning-reset-editor": "에디터를 초기화할 수 있습니다.",
  "learning-stop-code": "실행 중지",
  "learning-file-count": "{count}개의 파일",
  "learning-copy-clipboard": "클립보드에 복사되었습니다.",
  "learning-limit-permission-title": "수강할 수 있는 권한이 없습니다",
  "learning-limit-permission-description": "권한이 필요한 경우, {link} 메뉴를 통해 문의해주세요.",
  "learning-hide-top-bottom-bars": "상단/하단 바 숨기기",
  "learning-show-top-bottom-bars": "상단/하단 바 보기",
  "learning-front-preview-guide": "코드 수정 내용이 미리보기에 반영되었습니다.",
  "challenges-title": "챌린지",
  "challenges-description": "다양한 실전 기술 과제를 해결하여 실무 개발 역량을 검증받고 한 단계 더 나아가세요.",
  "common-live": "진행중",
  "common-upcoming": "진행 예정",
  "common-closed": "종료",
  "challenges-start-days": "{day}일 후에 시작",
  "challenges-start-tomorrow": "내일 시작",
  "challenges-start-today": "오늘 시작",
  "challenges-closed-days": "{day}일 후에 종료",
  "challenges-closed-tomorrow": "내일 종료",
  "challenges-closed-today": "오늘 종료",
  "challenges-entry-complete": "참가 완료",
  "challenges-participants-count": "{totalCount}명의 참가자",
  "challenges-certificate": "인증서",
  "common-all": "전체",
  "challenges-count": "개의 챌린지",
  "common-filters": "필터",
  "challenges-none-data": "아직 등록된 챌린지가 없습니다.",
  "common-load-more": "더보기",
  "challenges-leaderboard-submitted-questions-showing-participants": "리더보드에는 답안을 제출 완료한 참가자만 노출됩니다.",
  "common-period": "기간",
  "challenges-join-challenge": "챌린지 참가",
  "common-overview": "개요",
  "challenges-leaderboard": "리더보드",
  "common-guidelines": "규칙",
  "challenges-winner": "우승자",
  "challenges-final-ranking-info": "최종 순위 및 점수는 관리자 채점 후 표시됩니다.",
  "challenges-participant": "참가자",
  "common-delete-member": "탈퇴한 회원",
  "common-score": "점수",
  "challenges-submit-questions": "제출 완료 문제 수",
  "challenges-total-questions": "/ 총 문제 수",
  "challenges-last-submission": "최종 제출일",
  "challenges-none-participants-data": "아직 참가자가 없습니다.",
  "challenges-guidelines": "챌린지 규칙",
  "challenges-authentication-code-title": "인증코드를 입력해주세요",
  "challenges-authentication-code-description": "챌린지에 참가하려면 부여받은 인증코드를 입력해주세요.",
  "challenges-authentication-code-placeholder": "인증코드",
  "challenges-authentication-code-incorrect": "입력해주신 인증코드가 올바르지 않습니다.",
  "challenges-anti-cheating-guidance": "부정행위 방지 관련 안내",
  "challenges-anti-cheating-info-1": "공정성을 보장하고 부정행위를 방지하기 위해 실시간으로 모니터링하고 기록하는 기능이 활성화됩니다.",
  "challenges-anti-cheating-info-2": "다음과 같은 행동은 부정행위로 간주될 수 있으니 주의해 주시기 바랍니다.",
  "challenges-anti-cheating-screen-exit-detection": "화면에서 벗어나는 경우",
  "challenges-anti-cheating-screen-exit-detection-info-1": "2회 이상 발생 시 실격 처리될 수 있습니다.",
  "challenges-anti-cheating-screen-exit-detection-info-2": "단, 문의 작성이나 진행 과정에서 필요한 경우 등 불가피한 사유로 발생한 경우에는 불이익이 적용되지 않으니 안심하고 응시해주세요.",
  "challenges-anti-cheating-keyboard-shortcuts-restriction-and-detection": "허용되지 않는 단축키 사용을 시도한 경우",
  "challenges-anti-cheating-multiple-monitor-restriction-and-detection": "다중 모니터 사용을 시도한 경우",
  "challenges-anti-cheating-copy-cut-paste-detection": "외부 코드를 복사/잘라내기/붙여넣기 하는 경우",
  "challenges-anti-cheating-face-voice-recording": "카메라 또는 마이크 설정을 변경하거나 비활성화 하는 경우",
  "challenges-anti-cheating-face-voice-recording-info-1": "카메라 화면이 가려지거나 응시자 확인이 어려운 경우도 포함됩니다.",
  "challenges-agree-rules-title": "시작하기 전에 규칙에 동의해주세요",
  "challenges-agree-rules-description": "규칙을 읽고 이해했음을 동의합니다.",
  "common-agree": "동의",
  "common-confirm": "확인",
  "challenges-proctoring-full-screen-error": "챌린지를 진행하려면 전체 화면을 공유해야 합니다.",
  "challenges-back-to-challenge-detail": "챌린지 상세로 이동",
  "challenges-finish-challenge-title": "챌린지를 끝내시겠습니까?",
  "common-cancel": "취소",
  "challenges-finished-title": "챌린지가 종료되었습니다",
  "challenges-finished-description": "챌린지 시간이 종료되었습니다.\n챌린지에 응시해주셔서 감사합니다.",
  "common-dashboard": "대시보드",
  "common-skillCertify": "SkillCertify",
  "common-manageAssessment": "평가 관리",
  "common-takeAssessment": "평가 응시",
  "common-skillMonitor": "SkillMonitor",
  "common-skillAdvance": "SkillAdvance",
  "common-adaptiveLecture": "SkillFit",
  "advance-learn": "학습",
  "advance-practice": "연습",
  "common-choose-language": "언어 선택",
  "dashboard-info-greetings": "안녕하세요,",
  "dashboard-info-nickName": "{name}님",
  "common-closed-assessment": "종료된 평가 수",
  "dashboard-total-assessments": "총 평가 수",
  "dashboard-completed-candidates": "완료한 응시자 수",
  "dashboard-total-candidates": "총 응시자 수",
  "dashboard-completed-learning": "완료한 학습 수",
  "dashboard-total-learning": "총 학습 수",
  "dashboard-learning-points": "학습 포인트",
  "dashboard-total-point": "총 포인트",
  "dashboard-completed-practice": "완료한 연습 수",
  "dashboard-total-practice": "총 연습 수",
  "dashboard-completed-assessments": "완료한 평가 수",
  "dashboard-created-assessments": "생성된 평가",
  "dashboard-candidates": "응시자 수",
  "common-sample": "샘플",
  "skillCertify-none-created-assessment": "아직 생성된 평가가 없습니다.",
  "skillCertify-internal-assessment": "조직 역량 평가",
  "skillCertify-external-assessment": "외부 인재 평가",
  "dashboard-invited-assessments": "초대받은 평가",
  "dashboard-sample-assessments": "샘플 평가",
  "skillCertify-none-invited-assessment": "아직 초대받은 평가가 없습니다.",
  "advance-my-learning": "내 학습",
  "advance-my-learning-more": "내 학습 보기",
  "advance-position-learn": "학습 위치",
  "advance-permission-disable": "수강할 수 있는 권한이 없습니다. \n권한이 필요한 경우, 문의하기 메뉴를 통해 문의해주세요.",
  "advance-position-info": "코스 & 스킬 정보",
  "advance-learn-none-data": "아직 시작한 학습이 없습니다.",
  "advance-my-practice": "내 연습",
  "advance-my-practice-more": "내 연습 보기",
  "advance-position-practice": "연습 위치",
  "advance-practice-none-data": "아직 시작한 연습이 없습니다.",
  "advance-find-track": "트랙 탐색",
  "advance-my-learn-sub-description": "시작한 모든 학습의 개요입니다.",
  "common-in-progress": "진행중",
  "common-completed": "완료",
  "filter-field": "분야",
  "filter-select": "{count}개 선택됨",
  "advance-my-practice-sub-description": "시작한 모든 연습의 개요입니다.",
  "advance-learn-sub-description": "기술을 습득하고 직무 역량을 쌓아 커리어를 발전시키세요.",
  "advance-none-track": "아직 등록된 트랙이 없습니다.",
  "advance-practice-sub-description": "연습 평가를 통해 기술 및 직무 역량을 확인해보세요.",
  "advance-level-count": "{count}개의 레벨",
  "advance-course-count": "{count}개의 코스",
  "advance-related-practice": "관련된 연습",
  "advance-related-practice-info": "학습한 내용을 잘 이해했는지 확인해보세요.",
  "common-point-count": "{point} 포인트",
  "advance-not-start": "잠김",
  "advance-pre-start": "시작 전",
  "advance-ongoing": "진행중",
  "advance-related-learn": "관련된 학습",
  "advance-related-learn-info": "부족한 부분을 학습하여 보완해보세요.",
  "advance-my-level": "레벨 {level}",
  "skillCertify-manage-assessment-description": "필요한 맞춤형 평가를 손쉽게 생성하고, 기존 평가의 수정, 조회, 삭제 등을 간편하게 수행하세요.",
  "skillCertify-search-placeholder": "평가명 검색",
  "common-status": "상태",
  "skillCertify-assessment-count": "개의 평가",
  "skillCertify-create-assessment": "평가 생성",
  "common-information": "정보",
  "skillCertify-type": "유형",
  "common-question-info": "문제 수",
  "common-question-count": "{count}개의 문제",
  "common-duration": "평가 시간",
  "skillCertify-more-information": "추가 정보",
  "skillCertify-proctoring": "감독 기능",
  "skillCertify-constructor": "생성자",
  "skillCertify-creation-date": "생성일",
  "skillCertify-tracks-settings": "트랙 설정",
  "skillCertify-assessment-set-title-to-level-plural": "{title} - {level} 외 {count}",
  "skillCertify-assessment-set-title-to-level-singular": "{title} - {level}",
  "skillCertify-tracks-information-detail": "트랙 정보 상세",
  "skillCertify-pre-start": "평가 시작 전",
  "skillCertify-invited": "초대됨",
  "skillCertify-ready": "평가 준비 완료",
  "skillCertify-started": "평가 시작",
  "skillCertify-completed": "평가 완료",
  "skillCertify-view-actual-question": "실제 문제 보기",
  "skillCertify-actual-question": "실제 문제",
  "skillCertify-api-reference": "참고자료",
  "skillCertify-api-reference-description": "이 설정을 활성화하면 응시자들은 평가 진행 중에 참고자료를 확인할 수 있습니다.",
  "skillCertify-api-reference-view": "참고자료 보기",
  "skillCertify-add-track": "트랙 추가",
  "skillCertify-add-track-success": "트랙이 추가되었습니다.",
  "skillCertify-set-tip": "레벨을 선택해주세요.",
  "skillCertify-recommend-time": "권장 시간",
  "skillCertify-recommend-time-tip": "트랙을 해결하기 위해 권장되는 시간입니다.",
  "skillCertify-remove-track": "트랙 제거",
  "skillCertify-track-remove-title": "트랙을 제거하시겠습니까?",
  "common-remove": "제거",
  "skillCertify-remove-track-success": "트랙이 성공적으로 제거되었습니다.",
  "skillCertify-reset-track": "트랙 초기화",
  "skillCertify-category": "카테고리",
  "advance-track-name-placeholder": "트랙명 검색",
  "advance-track-count": "개의 트랙",
  "advance-track": "트랙",
  "skillCertify-view-description": "설명 보기",
  "advance-more-track": "트랙에 대해 더 알아보기",
  "skillCertify-view-guide": "가이드 보기",
  "advance-guide": "가이드",
  "advance-level": "레벨",
  "advance-level-general": "공통",
  "advance-level-entry": "입문",
  "advance-level-beginner": "초급",
  "advance-level-intermediate": "중급",
  "advance-level-professional": "전문가",
  "skillCertify-view-questions": "문제 보기",
  "skillCertify-select": "선택",
  "skillCertify-select-info": "레벨의 다양한 문제 세트 중 하나의 세트가 랜덤으로 선택됩니다.",
  "skillCertify-basic-info": "기본 정보",
  "skillCertify-assessment-name": "평가명",
  "skillCertify-assessment-name-placeholder": "평가명을 입력해주세요.",
  "skillCertify-assessment-internal": "조직 역량 평가",
  "skillCertify-assessment-external": "외부 인재 평가",
  "skillCertify-assessment-internal-description": "조직 역량 평가는 조직 진단을 통한 임직원 역량 파악, 인사 관리 등에 활용할 수 있습니다.",
  "skillCertify-assessment-external-description": "외부 인재 평가는 인재 채용, 협력사 선정 등 조직 외부의 사람들을 평가하는데 활용할 수 있습니다.",
  "skillCertify-period-info": "응시자들은 설정한 기간 내에서만 평가를 진행할 수 있습니다.",
  "common-open-date": "시작일",
  "common-at": "",
  "common-close-date": "종료일",
  "skillCertify-period-error-invalid-both": "종료일과 종료 시간은 시작일과 시작 시간보다 빠를 수 없습니다.",
  "skillCertify-time-zone": "시간대",
  "skillCertify-time-zone-placeholder": "시간대 검색",
  "common-optional": "선택 사항 | - 선택 사항",
  "skillCertify-candidates-find-tip": "응시자들은 평가에 대한 설명을 확인 할 수 있습니다.",
  "skillCertify-assessment-description-placeholder": "평가에 대한 설명을 입력해주세요.",
  "skillCertify-assessment-duration-tip": "트랙에 맞춰 평가 시간이 자동으로 설정되며 필요에 따라 평가 시간을 조절할 수 있습니다.",
  "skillCertify-assessment-duration-time-limit": "시간 제한",
  "common-duration-unlimited": "무제한",
  "skillCertify-assessment-duration-error": "평가 시간을 입력해야 합니다.",
  "skillCertify-assessment-duration-change": "이전 설정에 따라 평가 시간이 조절되었습니다.",
  "common-previous": "이전",
  "skillCertify-proctoring-description": "공정성을 보장하고 부정행위를 방지하기 위해 감독 기능을 사용하는 것을 권장합니다.",
  "skillCertify-no-proctoring": "사용 안 함",
  "skillCertify-basic-proctoring": "기본",
  "skillCertify-basic-proctoring-sub": "웹 브라우저",
  "skillCertify-advanced-proctoring": "강화",
  "skillCertify-advanced-proctoring-sub": "Proctive 프로그램",
  "skillCertify-proctoring-screen-exit-detection": "화면 이탈 감지",
  "skillCertify-proctoring-screen-exit-detection-description": "평가 진행 중 화면에서 벗어나는 경우를 감지할 수 있습니다.",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection": "단축키 제한 및 감지",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-1": "평가 진행 중 허용되지 않는 단축키 사용이 제한되며 사용을 시도한 경우를 감지할 수 있습니다.",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-2": "허용되지 않는 단축키:",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-3": "웹페이지 저장, 캡처, 소스 보기, 개발자 도구 열기와 관련된 단축키",
  "skillCertify-proctoring-multiple-monitor-restriction-and-detection": "다중 모니터 제한 및 감지",
  "skillCertify-proctoring-multiple-monitor-restriction-and-detection-description": "평가 진행 중 다중 모니터 사용이 제한되며 사용을 시도한 경우를 감지할 수 있습니다.",
  "skillCertify-proctoring-copy-cut-paste-detection": "복사/잘라내기/붙여넣기 감지",
  "skillCertify-proctoring-copy-cut-paste-detection-description": "평가 진행 중 코드나 텍스트를 복사하거나, 잘라내거나, 붙여넣는 경우를 감지할 수 있습니다.",
  "skillCertify-proctoring-partial-screen--recording": "화면 부분 녹화 (부정행위 발생 시)",
  "skillCertify-proctoring-partial-screen--recording-description-1": "평가 진행 중 부정행위가 발생한 시점의 화면이 기록됩니다.",
  "skillCertify-proctoring-partial-screen--recording-description-2": "부정행위가 감지되면 여러 장의 스크린샷이 캡처되며 이를 바탕으로 부정행위마다 별도의 영상이 생성됩니다.",
  "skillCertify-proctoring-partial-screen--recording-description-3": "녹화된 영상은 안전하게 저장되며 30일 후 영구 삭제됩니다.",
  "skillCertify-proctoring-partial-screen--recording-description-4": "영상은 관리자 채점 후 확인할 수 있습니다.",
  "skillCertify-proctoring-full-screen-recording": "화면 전체 녹화 (평가 전 과정)",
  "skillCertify-proctoring-full-screen-recording-description-1": "평가 시작부터 종료까지 화면이 녹화됩니다.",
  "skillCertify-proctoring-full-screen-recording-description-2": "부정행위가 발생한 시점이 기록되어 녹화된 영상에서 부정행위 발생 구간을 확인할 수 있습니다.",
  "skillCertify-proctoring-face-voice-recording": "얼굴/음성 녹화",
  "skillCertify-proctoring-face-voice-recording-description-1": "평가 시작 전 카메라와 마이크를 설정해야 합니다.",
  "skillCertify-proctoring-face-voice-recording-description-2": "평가 진행 중 얼굴과 음성이 녹화됩니다.",
  "skillCertify-assessment-create-success": "평가가 생성되었습니다.",
  "skillCertify-assessment-create-fail": "평가를 생성할 수 없습니다.\n다시 시도해주세요.",
  "skillCertify-assessment-info": "평가 정보",
  "skillCertify-candidates-list": "응시자 목록",
  "common-delete": "삭제",
  "skillCertify-assessment-delete-title": "평가를 삭제하시겠습니까?",
  "skillCertify-assessment-delete-info-1": "모든 응시자의 평가 결과도 삭제됩니다.",
  "skillCertify-assessment-delete-info-2": "'삭제'를 입력하면 [삭제] 버튼이 활성화됩니다.",
  "skillCertify-assessment-delete-success": "평가가 성공적으로 삭제되었습니다.",
  "skillCertify-assessment-delete-fail": "평가를 삭제할 수 없습니다.\n다시 시도해주세요.",
  "common-modify": "수정",
  "skillCertify-modify-limit-title": "평가를 수정할 수 없습니다",
  "skillCertify-modify-limit-description": "평가를 시작한 응시자가 있어서 평가를 수정할 수 없습니다.",
  "common-update": "업데이트",
  "skillCertify-modify-success": "평가가 업데이트되었습니다.",
  "skillCertify-modify-fail": "평가를 업데이트할 수 없습니다.\n다시 시도해주세요.",
  "common-invite": "초대",
  "skillCertify-invite-candidates": "응시자 초대",
  "skillCertify-invite-candidates-description": "이메일은 쉼표 또는 엔터키로 추가할 수 있습니다.\n응시자가 평가를 시작한다면 평가를 수정할 수 없습니다.",
  "skillCertify-invite-candidates-email-invalid": "'{email}' 이메일은 유효하지 않은 이메일입니다.",
  "skillCertify-invite-candidates-success": "{count}명의 응시자에게 평가 초대 메일이 발송되었습니다.",
  "skillCertify-invite-candidates-fail": "{count}명의 응시자를 초대할 수 없습니다.\n다시 시도해주세요.",
  "skillCertify-invite-candidates-duplicate-count": "이미 초대된 응시자가 {count}명 있습니다\n중복 제거 후 초대하시겠습니까?",
  "skillCertify-invite-candidates-duplicate-description": "중복 제거 후 신규 응시자만 초대됩니다.",
  "skillCertify-invite-candidates-duplicate-warning": "이미 초대된 응시자가 있습니다.",
  "learning-start-assessment": "평가 시작",
  "skillCertify-search-user-placeholder-new": "성명 또는 이메일 검색",
  "skillCertify-candidate-report": "리포트",
  "skillCertify-score-rank": "점수 순위",
  "skillCertify-skill-acquisition-rate-rank": "스킬 확보율 순위",
  "skillCertify-set-average-skill-acquisition-rate-info": "전체 트랙의 평균 스킬 확보율입니다.",
  "skillCertify-candidate-tracks-result-button": "트랙 결과 데이터 보기",
  "skillCertify-assessment-score-rank": "평가 점수 순위",
  "skillCertify-assessment-score": "평가 점수",
  "skillCertify-assessment-time-taken": "평가 소요 시간",
  "skillCertify-assessment-skill-acquisition-rate-rank": "평가 스킬 확보율 순위",
  "skillCertify-assessment-skill-acquisition-rate": "평가 스킬 확보율",
  "profile-full-name": "성명",
  "common-link-copy": "링크가 클립보드에 복사되었습니다.",
  "skillCertify-candidate-count": "명의 응시자",
  "skillCertify-candidate-info": "응시자 정보",
  "skillCertify-candidate-last-record": "최근 기록",
  "skillCertify-candidate-invited-date": "초대일",
  "skillCertify-candidate-ready-date": "평가 준비 완료일",
  "skillCertify-candidate-started-date": "평가 시작일",
  "skillCertify-candidate-completed-date": "평가 완료일",
  "common-time-taken": "소요 시간",
  "common-view": "보기",
  "skillCertify-rank": "순위",
  "skillCertify-candidate-resend-email": "메일 재발송",
  "skillCertify-candidate-resend-email-description": "'{email}'님에게 평가 초대 메일을 다시 보내시겠습니까?",
  "common-resend": "재발송",
  "skillCertify-candidate-resend-email-success": "'{email}'님에게 평가 초대 메일이 재발송되었습니다.",
  "skillCertify-candidate-resend-email-fail": "'{email}'님에게 평가 초대 메일을 재발송할 수 없습니다.\n다시 시도해주세요.",
  "skillCertify-set-average-score-info": "전체 트랙의 평균 점수입니다.",
  "skillCertify-action-timeline": "타임라인",
  "skillCertify-action-record-count": "개의 기록",
  "skillCertify-candidate-assessment-result": "평가 결과",
  "skillCertify-score-grading": "채점중",
  "skillCertify-score-none-description": "관리자 수동 채점으로 다소 시간이 소요될 수 있습니다.",
  "skillCertify-candidate-report-button": "리포트 보기",
  "common-read-more": "더보기",
  "skillCertify-candidate-none-data": "응시자가 없습니다.",
  "skillCertify-candidate-select": "{count}명의 응시자 선택됨",
  "skillCertify-delete-candidates": "응시자 삭제",
  "skillCertify-candidate-delete-1": "명의 응시자를 삭제하시겠습니까?",
  "skillCertify-candidate-delete-2": "",
  "skillCertify-candidate-delete-description": "응시자의 평가 결과도 삭제됩니다.",
  "skillCertify-candidate-delete-success": "{count}명의 응시자가 성공적으로 삭제되었습니다.",
  "skillCertify-candidate-delete-fail": "{count}명의 응시자를 삭제할 수 없습니다.\n다시 시도해주세요.",
  "learning-view-guidelines": "규칙 보기",
  "learning-continue-assessment": "평가 이어하기",
  "skillCertify-account-miss-match": "계정 정보가 일치하지 않아 접근할 수 없습니다",
  "skillCertify-account-miss-match-description": "현재 로그인된 계정과 초대 메일을 받은 계정이 일치하지 않습니다.\n로그아웃 후 다시 로그인해주시고 문제가 지속되는 경우, 관리자에게 문의해주세요.",
  "skillCertify-limit-permission-title": "평가를 진행할 수 있는 권한이 없습니다",
  "skillCertify-limit-permission-description": "권한이 필요한 경우, 관리자에게 문의해주세요.",
  "skillCertify-assessment-duration-guide": "평가 시작 전 평가 시간을 확인해주세요",
  "skillCertify-assessment-duration-description-1": "평가 종료일에 따라 평가 시간이 설정됩니다.",
  "skillCertify-assessment-duration-description-2": "설정될 평가 시간 : {hour}시간 {minute}분",
  "skillCertify-assessment-guidelines": "평가 규칙",
  "learning-assessment-guide-line-description-1": "본 {target}는 {element}를 통해 참여해주세요.",
  "learning-assessment-guild-line-element-1": "Chrome 브라우저",
  "learning-assessment-guide-line-description-2": "문제 내용의 전체 또는 일부를 캡처하거나 복사하는 행위를 엄격히 금지합니다.",
  "learning-assessment-guide-line-description-3": "출제된 문제와 관련된 정보 및 본인의 답안을 인터넷 상에 게시하거나 타인에게 공유하는 행위를 금지합니다.",
  "learning-assessment-guide-line-description-4": "개인의 응시 환경(네트워크 장애 포함)으로 인한 문제와 참가자에게 안내되는 사항을 숙지하지 않아 발생한 불이익은 책임지지 않습니다.",
  "learning-assessment-guide-line-description-5": "반드시 네트워크 연결이 원활한 장소에서 응시하여야 하며, 카페나 도서관 등 공용 네트워크를 사용하는 장소는 권장하지 않습니다.",
  "learning-assessment-guide-line-description-6": "{target} 시간 관리의 책임은 전적으로 참가자 본인에게 있습니다. 답안을 {target} 종료 시간 내에 제출하지 못할 경우 불이익이 발생할 수 있습니다.",
  "learning-assessment-guide-line-description-7": "실습 중 코드 저장 기능을 사용할 수 있습니다.\n코드 저장 단축키는 다음과 같습니다.{element}",
  "learning-assessment-guild-line-element-2": "Windows 사용자: Ctrl + S",
  "learning-assessment-guild-line-element-3": "맥북 및 아이맥 사용자: Command + S",
  "learning-assessment-guide-line-description-8": "ChatGPT 및 유사 프로그램을 사용하는 경우 0점 처리될 수 있습니다. 부정행위 방지 솔루션으로 검증될 예정입니다.",
  "learning-assessment-guide-line-description-9": "{target} 참여중 부정행위가 발생하면 시스템에 의해 기록되며, 관리자에게 보고될 수 있습니다.",
  "learning-assessment-guide-line-description-10": "부정행위 방지 솔루션을 사용하지 않거나 {target} 참여 도중 중단하는 경우, 참여 결과가 무효화될 수 있습니다.",
  "learning-assessment-guide-line-description-for-mac-1": "부정행위 방지 솔루션을 사용하기 위해 맥북 및 아이맥 사용자는 화면 기록에 대한 접근 권한을 설정해야 합니다.",
  "learning-assessment-guide-line-description-for-mac-2": "설정 경로는 다음과 같습니다.",
  "learning-assessment-guide-line-description-for-mac-3": "Apple 메뉴 → 시스템 환경설정 → 보안 및 개인 정보 보호 → 화면 기록 → 자물쇠 해제 → Google Chrome 체크 → 브라우저 재시작",
  "learning-assessment-guide-line-description-for-mac-4": "Apple 메뉴 → 시스템 환경설정 → 보안 및 개인 정보 보호 → 화면 기록 → 자물쇠 해제 → Proctive 체크 → Proctive 재시작",
  "learning-assessment-guide-line-description-11": "부정행위 방지 솔루션의 지침을 따르지 않아 발생하는 불이익에 대한 책임은 참가자 본인에게 있습니다.",
  "common-question": "문제",
  "skillCertify-assessment-outline": "평가 목차",
  "skillCertify-assessment": "평가",
  "skillCertify-api-reference-info": "참고자료를 확인할 수 있습니다.",
  "common-description-button": "설명 팝업 열기",
  "learning-finish": "평가 끝내기",
  "skillCertify-assessment-finish-question-title": "평가를 끝내시겠습니까?",
  "skillCertify-assessment-finish-question-description-success-submitted": "모든 답안이 제출되었습니다.",
  "skillCertify-assessment-finish-question-description-not-submitted": "아직 제출하지 않은 답안이 있으니 제출해주세요.",
  "skillCertify-assessment-finish-question-description-common": "지금 평가를 끝내면 더 이상 평가를 보거나 수정할 수 없습니다.",
  "skillCertify-assessment-finish-question-description-check": "다시 한번 확인해주세요.",
  "skillCertify-assessment-finish-question-button": "끝내기",
  "skillCertify-caution": "주의",
  "skillCertify-caution-tab-switch": "화면에서 벗어난 행동이 확인되었습니다.\n관리자에게 보고되므로 완료할 때까지 화면에서 벗어나지 말아주세요.",
  "common-continue": "이어하기",
  "skillCertify-caution-tab-toast": "관리자에게 보고되므로 완료할 때까지 화면에서 벗어나지 말아주세요.",
  "skillCertify-caution-short-cut-1": "허용되지 않는 단축키를 사용한 행동이 확인되었습니다.\n관리자에게 보고되므로 완료할 때까지 허용되지 않는 단축키를 사용하지 말아주세요.",
  "skillCertify-caution-short-cut-2": "아래의 행동과 관련된 단축키는 허용되지 않습니다.",
  "skillCertify-caution-short-cut-key-word-1": "웹페이지 저장",
  "skillCertify-caution-short-cut-key-word-2": "캡처",
  "skillCertify-caution-short-cut-key-word-3": "소스 보기",
  "skillCertify-caution-short-cut-key-word-4": "개발자 도구 열기",
  "skillCertify-caution-short-cut-toast": "관리자에게 보고되므로 완료할 때까지 허용되지 않는 단축키를 사용하지 말아주세요.",
  "skillCertify-caution-multiple-monitor": "다중 모니터를 사용한 행동이 확인되었습니다.\n관리자에게 보고되므로 완료할 때까지 다중 모니터를 사용하지 말아주세요.",
  "skillCertify-proctoring-face-voice-recording-no-detect-title": "카메라/마이크를 감지할 수 없습니다",
  "skillCertify-proctoring-face-voice-recording-no-detect-description": "감독 기능이 중단되어 진행할 수 없습니다.\n처음 화면으로 돌아가서 카메라/마이크를 다시 설정하고 이어서 진행해주세요.",
  "skillCertify-proctoring-face-voice-recording-no-detect-button": "처음 화면으로 이동",
  "hands-on-environment-setup-loading": "실습 환경 세팅중입니다.",
  "hands-on-environment-setup-loading-title": "조금만 더 기다려주세요.",
  "hands-on-environment-setup-completed": "실습 환경 세팅이 완료되었습니다.",
  "hands-on-environment-setup-completed-info": "아래 버튼을 클릭하여 실습을 진행할 수 있습니다.",
  "hands-on-environment-setup-completed-button": "실습 진행",
  "hands-on-environment-setup-failed": "실습 환경 세팅에 실패했습니다.",
  "hands-on-environment-setup-failed-info": "아래 버튼을 클릭하여 실습 환경 세팅을 재진행할 수 있습니다.",
  "hands-on-environment-setup-failed-button": "실습 환경 세팅 재진행",
  "hands-on-environment-setup-description": "실습 환경 세팅은 {time} 정도 소요될 수 있습니다.",
  "hands-on-environment-setup-description-time": "약 {time}분",
  "embed-provisioning-phase-queued": "사용 가능한 자원을 기다리고 있어요…",
  "embed-provisioning-phase-launching": "실습 환경을 시작하고 있어요…",
  "embed-provisioning-expired-info": "예상보다 오래 걸리고 있어요. 다시 시도해주세요.",
  "embed-provisioning-still-preparing": "실습 환경을 아직 준비하고 있어요. 조금 더 기다리거나 다시 시도할 수 있어요.",
  "learning-run-code-and-save": "실행 및 저장",
  "learning-rerun-and-save": "재실행 및 저장",
  "learning-saved": "저장되었습니다.",
  "learning-save-failed": "저장에 실패했습니다.",
  "skillCertify-end-time-info-title": "평가 종료까지 {minutes}분 남았습니다\n답안 제출 여부를 다시 한번 확인해주세요",
  "skillCertify-end-time-info-description": "아직 제출하지 않은 답안이 있다면 제출해주세요.",
  "skillCertify-assessment-finish-title": "평가가 종료되었습니다",
  "skillCertify-assessment-finish-description": "평가 시간이 종료되었습니다.\n평가에 응시해주셔서 감사합니다.",
  "learning-fail-message": "일시적인 오류로 인해 제출할 수 없습니다.",
  "learning-fail-message-retry": "다시 시도해주세요.",
  "skillCertify-assessment-completed-title": "관리자에게 제출한 답안이 발송되었습니다",
  "skillCertify-assessment-completed-description": "경험과 역량을 잘 드러낼 수 있도록 프로필도 완성해보세요.",
  "skillCertify-assessment-completed-go-profile": "프로필로 이동",
  "skillCertify-load-template": "템플릿 불러오기",
  "skillCertify-template": "템플릿",
  "skillCertify-template-none-save-data": "아직 저장된 템플릿이 없습니다.",
  "common-apply": "적용",
  "skillCertify-template-load-title": "템플릿을 불러오시겠습니까?",
  "skillCertify-template-load-info": "기존에 설정된 트랙은 제거되고 선택한 템플릿의 트랙으로 대체됩니다.",
  "skillCertify-template-load-success": "템플릿이 적용되었습니다.",
  "skillCertify-save-template": "템플릿으로 저장",
  "skillCertify-template-save-title": "트랙을 템플릿으로 저장하시겠습니까?",
  "skillCertify-template-save-info-1": "저장된 템플릿은 {element} 사용할 수 있습니다.",
  "skillCertify-template-save-info-2": "평가 생성 및 수정 시",
  "skillCertify-template-name-placeholder": "템플릿명을 입력해주세요.",
  "skillCertify-error-template-name": "템플릿명은 1~30자 사이여야 합니다.",
  "skillCertify-template-save-success": "템플릿이 저장되었습니다.",
  "skillCertify-template-save-fail": "템플릿을 저장할 수 없습니다.\n다시 시도해주세요.",
  "skillCertify-template-management": "템플릿 관리",
  "skillCertify-search-template-name-placeholder": "템플릿명 검색",
  "skillCertify-template-edit-title": "템플릿명을 수정하시겠습니까?",
  "skillCertify-template-edit-success": "템플릿명이 수정되었습니다.",
  "skillCertify-template-edit-fail": "템플릿명을 수정할 수 없습니다.\n다시 시도해주세요.",
  "skillCertify-template-delete-title": "템플릿을 삭제하시겠습니까?",
  "skillCertify-template-delete-success": "템플릿이 성공적으로 삭제되었습니다.",
  "skillCertify-template-delete-fail": "템플릿을 삭제할 수 없습니다.\n다시 시도해주세요.",
  "skillCertify-caution-multiple-monitor-title": "모니터 설정을 확인해주세요",
  "skillCertify-caution-multiple-monitor-description": "다중 모니터 사용은 부정행위로 간주될 수 있습니다.\n다중 모니터가 연결되어 있다면 연결을 해제해주세요.",
  "skillCertify-caution-multiple-monitor-enable": "다중 모니터가 연결되지 않은 상태",
  "skillCertify-caution-multiple-monitor-disable-1": "다중 모니터가 연결된 상태",
  "skillCertify-caution-multiple-monitor-disable-2": "(연결 해제 필요)",
  "skillCertify-caution-recording-title": "녹화에 동의해주세요",
  "skillCertify-caution-recording-description-basic": "부정행위를 방지하기 위해 화면을 녹화할 예정입니다.\n녹화된 영상은 안전하게 저장되며 30일 후 영구 삭제됩니다.",
  "skillCertify-caution-recording-agree-basic": "화면 녹화에 동의합니다.",
  "skillCertify-caution-recording-description": "부정행위를 방지하기 위해 화면과 얼굴/음성을 녹화할 예정입니다.\n녹화된 영상은 안전하게 저장되며 30일 후 영구 삭제됩니다.",
  "skillCertify-caution-recording-agree": "화면과 얼굴/음성 녹화에 동의합니다.",
  "skillCertify-install-proctoring-program-title": "Proctive를 설치해주세요",
  "skillCertify-install-proctoring-program-description": "진행을 위해 감독 프로그램 설치가 필요합니다.\n아래 링크를 통해 감독 프로그램을 설치해주세요.",
  "skillCertify-install-proctoring-program-description-bold": "설치 후 이 창을 닫고 다시 시도해주세요.",
  "skillCertify-update-proctoring-program-title": "Proctive를 업데이트해주세요",
  "skillCertify-update-proctoring-program-description": "진행을 위해 감독 프로그램 업데이트가 필요합니다.\n아래 링크를 통해 감독 프로그램을 업데이트해주세요.",
  "skillCertify-basic-proctoring-recording-fail-title": "녹화가 정상적으로 이루어지지 않고 있습니다",
  "skillCertify-basic-proctoring-recording-fail-description": "녹화가 정상적으로 이루어지지 않아 평가를 진행할 수 없습니다.\n다시 시도해보시고 문제가 지속되는 경우, {email}로 문의해주세요.",
  "skillCertify-proctoring-recording-fail-title": "녹화가 정상적으로 이루어지지 않고 있습니다\n아래 내용을 확인한 후 Proctive를 재실행해주세요",
  "skillCertify-proctoring-recording-fail-description": "카메라/마이크에 대한 권한 또는 연결 상태를 확인",
  "skillCertify-proctoring-face-voice-recording-set-up-title": "카메라와 마이크를 설정해주세요",
  "skillCertify-proctoring-face-voice-recording-set-up-camera": "카메라",
  "skillCertify-proctoring-face-voice-recording-set-up-microphone": "마이크",
  "skillCertify-proctoring-face-voice-recording-set-up-retry": "재시도",
  "skillCertify-proctoring-face-voice-recording-set-up-retry-description": "카메라/마이크 연결을 다시 확인합니다.",
  "skillCertify-proctoring-face-voice-recording-set-up-fail-title": "카메라/마이크 연결에 실패했습니다",
  "skillCertify-proctoring-face-voice-recording-set-up-fail-description": "카메라/마이크에 대한 권한 또는 연결 상태를 확인해주세요.",
  "skillCertify-proctoring-screen-record-title": "전체 화면을 공유해주세요",
  "skillCertify-proctoring-full-screen-error": "평가를 진행하려면 **전체 화면**을 공유해야 합니다.",
  "skillCertify-proctoring-entire-screen-recording-no-access-title": "화면 녹화를 진행할 수 없습니다\n아래 내용을 확인해주세요",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-1": "화면 기록에 대한 접근 권한이 설정되어 있는지 확인",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-2": "스크린샷 차단 또는 녹화 방지 프로그램이 실행 중인지 확인",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-3": "문제가 지속되는 경우, {email}로 문의해주세요.",
  "skillCertify-aws-label": "AWS",
  "skillCertify-web-ide-label": "Web IDE",
  "skillCertify-prompt-label": "Prompt",
  "skillCertify-agent-prompt-label": "Agent Prompt",
  "skillCertify-command-multiple-choice-label": "명령어 & 객관식",
  "skillCertify-command-label": "명령어",
  "skillCertify-code-no-run-code-label": "코드 실습 (실행 없음)",
  "skillCertify-command-short-answer-label": "명령어 & 단답형",
  "skillCertify-code-label": "코드 실습",
  "skillCertify-multiple-files-code-label": "멀티파일 코드 실습",
  "skillCertify-jupyter-notebook-label": "Jupyter Notebook",
  "skillCertify-coding-agent-label": "Coding Agent",
  "skillCertify-take-assessment-description": "초대받은 모든 평가와 샘플 평가의 개요입니다.",
  "skillCertify-sample-information-title": "샘플 평가 시작 전 안내사항을 확인해주세요",
  "skillCertify-sample-information-new-description-1": "샘플 평가는 감독 기능 또는 문제 유형을 미리 체험해보기 위한 평가로 정답 및 결과는 제공되지 않습니다.",
  "skillCertify-sample-information-new-description-2": "감독 기능으로 인해 발생하는 녹화 및 행동 기록은 저장되지 않으며 관리자에게도 보고되지 않습니다.",
  "skillCertify-sample-information-new-description-3": "코드 실습 샘플 평가는 실제 평가와 다른 프로그래밍 언어로 제공될 수 있습니다.",
  "skillCertify-sample-information-new-description-4": "초대받은 평가에 응시하기 전까지 샘플 평가를 체험하실 수 있습니다. (평가 종료 시 이용 불가)",
  "skillCertify-sample-unavailable-description": "현재 샘플 평가를 체험하실 수 없습니다.\n진행 예정이거나 진행 중인 평가에 초대되면 체험하실 수 있습니다.",
  "skillCertify-sample-token-limit-info": "이 평가는 토큰 사용량이 제한되어, 한도에 도달하면 응답 생성이 중단됩니다.",
  "skillCertify-sample-assessment-completed-title": "샘플 평가를 완료했습니다",
  "skillCertify-sample-assessment-completed-description": "재응시하거나 다른 샘플 평가도 체험해보세요.",
  "skillCertify-sample-assessment-completed-try-sample-assessment": "샘플 평가 체험하기",
  "skillCertify-command-question-type": "문제 유형",
  "skillCertify-command-basic-proctoring-label": "기본 감독",
  "skillCertify-command-advanced-proctoring-label": "강화 감독",
  "skillCertify-proctoring-screen-record-description-3": "생성된 영상은 30일 후 영구 삭제됩니다.",
  "common-retry": "다시 시도",
  "assessment-provision-failed": "실습 환경 준비에 실패했습니다.\n다시 시도하거나, 문제가 계속되면 문의해주세요.",
  "skillCertify-advanced-proctoring-restriction-info": "강화 감독은 프로, 엔터프라이즈 플랜에서 사용할 수 있습니다.",
  "skillCertify-advanced-proctoring-restriction-info-2": "강화 감독 사용을 희망하시는 경우, 전담 매니저에게 문의해주세요.",
  "skillCertify-report-language-tip": "선택한 언어로 평가 리포트와 응시자 리포트가 생성됩니다.",
  "skillCertify-report-language-info-1": "베이직 플랜은 언어를 1개만 선택할 수 있습니다.",
  "skillCertify-report-language-info-2": "프로, 엔터프라이즈 플랜에서는 언어를 추가로 선택할 수 있습니다.",
  "skillCertify-creation-restriction-info-1-title": "구독 중인 플랜이 없어\n평가를 생성할 수 없습니다",
  "skillCertify-creation-restriction-info-2-title": "구독이 종료되어\n평가를 생성할 수 없습니다",
  "credit-certify-creation-limit-description-1": "평가 초대 크레딧이 필요한 경우, {linkDom}에서 크레딧 충전을 진행해주세요.",
  "credit-certify-creation-limit-description-2": "크레딧 관리",
  "credit-certify-creation-limit-button": "크레딧 관리로 이동",
  "credit-certify-invitation-restriction-info-title": "구독이 종료되어\n응시자를 초대할 수 없습니다",
  "skillCertify-assessment-time-added": "{minutes}분 추가됨",
  "skillCertify-assessment-time-extension-history": "시간 추가 내역",
  "skillCertify-assessment-total-added-time": "총 추가된 시간",
  "skillCertify-assessment-time-added-toast": "평가 시간이 {minutes}분 추가되었습니다.",
  "skillCertify-core-label": "Core",
  "skillCertify-e2e-label": "E2E",
  "skillCertify-aI-fluent-label": "AI Fluent",
  "skillCertify-plan-restriction-info": "프로 / 엔터프라이즈 플랜 전용",
  "skillCertify-calculation-basis": "산정 기준",
  "skillCertify-credit": "크레딧",
  "skillCertify-track-count": "{count}개",
  "skillCertify-credit-count": "{count}개",
  "skillCertify-credit-info": "응시자 1명 초대 시 평가 초대 크레딧",
  "skillCertify-credit-info-1": "{count}개",
  "skillCertify-credit-info-2": "사용 예정",
  "skillCertify-select-disabled-info-1": "Core 또는 E2E 트랙이 선택되어 있어 AI Fluent 트랙을 선택할 수 없습니다.",
  "skillCertify-select-disabled-info-1-1": "AI Fluent 트랙은 단독으로만 구성할 수 있습니다.",
  "skillCertify-select-disabled-info-2": "AI Fluent 트랙이 선택되어 있어 다른 트랙을 선택할 수 없습니다.",
  "skillCertify-select-disabled-info-2-1": "AI Fluent 트랙은 단독으로만 구성할 수 있습니다.",
  "skillCertify-tracks-settings-disabled-info-1": "응시자를 초대한 이후에는 트랙을 변경할 수 없습니다.",
  "skillCertify-tracks-settings-disabled-info-2": "기본 정보와 감독 기능은 다음 단계에서 수정할 수 있으며, 초대된 응시자를 모두 삭제하면 트랙도 다시 변경할 수 있습니다.",
  "skillCertify-invite-candidates-candidate-count": "응시자 {count} 명 초대",
  "skillCertify-invite-candidates-credit-count": "크레딧 {count} 개 사용 예정",
  "skillCertify-invite-candidates-credit-count-per-candidate": "1명당 {count}개 사용 예정",
  "skillCertify-invite-candidates-estimated-remaining": "초대 후 예상 잔여",
  "skillCertify-invite-candidates-insufficient-credits": "부족한 크레딧",
  "skillCertify-calculation-basis-track-count": "설정한 트랙 수",
  "skillCertify-calculation-basis-credit-count": "차감될 크레딧 수",
  "webcam-recording-active": "웹캠 녹화 중",
  "SkillCertify-duplicate-session-warning-title": "다른 화면에서 평가가 시작되었습니다",
  "SkillCertify-duplicate-session-warning-description": "현재 화면에서는 더 이상 평가를 진행할 수 없습니다.",
  "skillCertify-tracks-setup-method": "트랙 설정 방식",
  "skillCertify-tracks-setup-manual": "직접 설정",
  "skillCertify-tracks-select-manually": "직접 트랙 선택하기",
  "skillCertify-tracks-ai-recommendation": "AI 추천",
  "skillCertify-tracks-get-recommendation": "트랙 추천받기",
  "skillCertify-tracks-setup-method-change-title": "트랙 설정 방식을 변경하시겠습니까?",
  "skillCertify-tracks-setup-method-change-description": "현재 설정된 트랙이 초기화됩니다.",
  "skillCertify-tracks-recommendation-input-guide": "트랙 추천에 필요한 정보를 입력해주세요.",
  "skillCertify-tracks-recommendation-credit-info": "추천받기 시 AI 추천 횟수가 1회 차감됩니다.",
  "skillCertify-tracks-recommendation-monthly-limit-basic": "월 5회",
  "skillCertify-tracks-recommendation-monthly-limit-pro": "월 20회",
  "skillCertify-tracks-recommendation-job-role": "직무",
  "skillCertify-tracks-recommendation-job-role-placeholder": "직무를 선택해주세요.",
  "skillCertify-tracks-recommendation-job-role-backend": "백엔드 개발자",
  "skillCertify-tracks-recommendation-job-role-frontend": "프론트엔드 개발자",
  "skillCertify-tracks-recommendation-job-role-ai-ml": "AI/ML 엔지니어",
  "skillCertify-tracks-recommendation-work-experience-placeholder": "경력을 선택해주세요.",
  "skillCertify-tracks-recommendation-work-experience-entry": "신입~2년",
  "skillCertify-tracks-recommendation-work-experience-mid": "3~5년",
  "skillCertify-tracks-recommendation-work-experience-senior": "6년+",
  "skillCertify-tracks-recommendation-keywords": "직무기술서 또는 기술 키워드",
  "skillCertify-tracks-recommendation-keywords-placeholder": "직무기술서 또는 기술 키워드를 입력해주세요.\n예: Python, Java, AWS 등",
  "skillCertify-tracks-recommendation-submit": "추천받기",
  "skillCertify-tracks-recommendation-limit-reached": "AI 추천 횟수를 모두 사용했습니다.\n다음 갱신 시 다시 이용할 수 있습니다.",
  "skillCertify-tracks-recommendation-fail": "일시적인 오류로 인해 추천받기를 진행할 수 없습니다.\n다시 시도해주세요.",
  "skillCertify-tracks-recommendation-loading": "AI가 적합한 트랙을 찾고 있습니다.\n잠시만 기다려주세요.",
  "skillCertify-tracks-recommendation-no-result": "입력하신 조건에 맞는 추천 트랙을 찾지 못했습니다.\n입력한 정보를 수정해서 다시 시도해주세요.",
  "skillCertify-tracks-recommendation-edit-info": "입력한 정보 수정하기",
  "skillCertify-tracks-recommendation-entered-info": "입력 정보",
  "skillCertify-tracks-recommendation-result": "추천 트랙",
  "skillCertify-tracks-recommendation-result-guide": "아래 추천 트랙 중 설정할 트랙을 선택해주세요.",
  "skillCertify-tracks-recommendation-matching-basis": "매칭 근거",
  "skillCertify-tracks-recommendation-no-desired-track": "원하는 트랙이 없으신가요?",
  "skillCertify-tracks-recommendation-edit-info-title": "입력한 정보를 수정하시겠습니까?",
  "skillCertify-tracks-recommendation-edit-info-description": "현재 추천 트랙이 초기화됩니다.",
  "skillCertify-tracks-recommendation-apply-selected": "선택한 트랙 적용",
  "skillCertify-tracks-recommendation-apply-success": "추천 트랙이 적용되었습니다.",
  "skillCertify-current-question": "현재 문제",
  "skillCertify-answer-status-not-submitted": "미제출",
  "skillCertify-answer-status-submitted": "제출 완료",
  "skillCertify-answer-status-resubmit-required": "재제출 필요",
  "skillCertify-submit-answer-for-grading": "채점을 위해 답안 제출도 완료해주세요.",
  "skillCertify-away-with-out-title": "현재 문제의 답안이 아직 제출되지 않았습니다\n답안을 제출하시겠습니까?",
  "skillCertify-away-with-out-description-1": "이동하기 전에 답안을 제출하는 것을 권장합니다.",
  "skillCertify-away-with-out-description-2": "제출 후에도 추가 변경 사항이 있다면 다시 제출하실 수 있습니다.",
  "skillCertify-away-with-out-leave": "제출하지 않고 이동",
  "skillCertify-locale-change-with-out-submitting-description": "언어를 변경하기 전에 답안을 제출하는 것을 권장합니다.",
  "skillCertify-locale-change-with-out-submitting": "제출하지 않고 언어 변경",
  "skillCertify-submit-answer-require-run-code-and-save": "답안을 제출하려면 먼저 실행 및 저장을 완료해주세요.",
  "skillCertify-question-provides-api-reference": "이 문제는 {resourcesLink}를 제공합니다.",
  "skillMonitor-main-description": "정확하게 측정된 조직 구성원과 외부 인력의 역량 데이터를 모니터링하고 프로젝트 배치, 교육, 채용 등 의사결정에 효과적으로 활용하세요.",
  "skillMonitor-main-sample-title": "현재는 샘플 데이터를 확인할 수 있습니다.",
  "skillMonitor-main-sample-description": "평가를 생성하면 실제 데이터로 표시됩니다.",
  "skillMonitor-main-sample-do-not-again": "다시 보지 않기",
  "skillMonitor-main-limit-permission-title": "페이지에 접근할 수 있는 권한이 없습니다",
  "skillMonitor-main-limit-permission-description": "소속된 조직과 관련된 페이지만 확인할 수 있습니다.",
  "skillMonitor-assessments-overview": "평가 개요",
  "skillMonitor-candidates-overview": "응시자 개요",
  "common-total": "총",
  "skillMonitor-closed-assessment-count": "종료된 평가",
  "skillMonitor-chart-last": "지난",
  "skillMonitor-chart-months": "12개월",
  "skillMonitor-summary-none-closed-assessment": "아직 종료된 평가가 없습니다.",
  "skillMonitor-chart-completed-candidates-count": "완료한 응시자",
  "skillMonitor-summary-none-closed-candidate": "아직 완료한 응시자가 없습니다.",
  "common-average": "평균",
  "skillMonitor-main-track-level": "레벨 분포",
  "skillMonitor-chart-none-track-level": "아직 응시자들의 레벨 분포가 없습니다.",
  "skillMonitor-chart-track-level": "응시자들의 트랙 레벨 분포",
  "skillCertify-candidate": "응시자",
  "skillMonitor-main-assessment-list": "평가 목록",
  "skillMonitor-main-assessment-list-more": "모든 평가 보기",
  "skillMonitor-completed-candidate": "완료한 응시자",
  "skillMonitor-main-candidate-list-more": "모든 응시자 보기",
  "skillMonitor-main-assessment-list-banner": "조직에서 생성한 평가를 확인할 수 있습니다.",
  "skillMonitor-candidate-list-banner": "평가를 완료한 응시자들을 확인할 수 있습니다.",
  "skillMonitor-action-date": "행동 발생일",
  "skillMonitor-action-screen-switch": "화면 전환",
  "skillMonitor-action-shortcut": "허용되지 않는 단축키",
  "skillMonitor-action-multi-monitor": "다중 모니터 연결됨",
  "skillMonitor-action-copy": "복사",
  "skillMonitor-action-cut": "잘라내기",
  "skillMonitor-action-paste": "붙여넣기",
  "skillMonitor-action-type": "행동 유형",
  "skillMonitor-filter-by": "필터 기준",
  "skillMonitor-track-info": "트랙 정보",
  "skillMonitor-assessment-submission": "제출물",
  "skillMonitor-assessment-partially-answer": "부분 정답",
  "skillMonitor-assessment-incorrect-answer": "오답",
  "skillMonitor-assessment-incorrect": "오답",
  "skillMonitor-assessment-answerer": "{userName}님의 답안",
  "skillMonitor-assessment-answerer-none": "제출된 답안이 없습니다.",
  "skillMonitor-analysis-title": "{userName}님의 지표",
  "skillMonitor-analysis-metric-name": "정적 분석 항목",
  "common-result": "결과",
  "skillMonitor-analysis-severity": "심각도",
  "skillMonitor-analysis-metric-tooltip-DUPLICATIONS": "코드 중복을 나타냅니다.",
  "skillMonitor-analysis-metric-tooltip-CYCLOMATIC_COMPLEXITY": "코드의 복잡성을 측정하는 지표로, 프로그램의 논리적 경로 수를 계산합니다. 조건문이나 반복문이 많을수록 복잡도가 높아집니다.",
  "skillMonitor-analysis-metric-tooltip-BUGS": "코드에 포함된 잠재적인 버그를 나타냅니다.",
  "skillMonitor-analysis-metric-tooltip-CODING_STYLE": "코드가 일관된 스타일과 표준을 따르고 있는지 평가합니다.",
  "skillMonitor-analysis-code-smell": "코드 스멜",
  "skillMonitor-analysis-code-smell-long-method": "메서드가 너무 길어 하나의 메서드에 너무 많은 작업이 포함된 경우.",
  "skillMonitor-analysis-code-smell-large-class": "클래스가 지나치게 많은 필드와 메서드를 가지며, 너무 많은 책임을 담당하는 경우.",
  "skillMonitor-analysis-code-smell-primitive-obsession": "기본 데이터 타입(int, string 등)을 과도하게 사용하여 도메인 모델이 명확하지 않은 경우.",
  "skillMonitor-analysis-code-smell-long-parameter-list": "메서드의 매개변수 개수가 지나치게 많아 사용과 유지보수가 어려운 경우.",
  "skillMonitor-analysis-code-smell-data-clumps": "특정 데이터 그룹이 자주 함께 나타나는 경우.",
  "skillMonitor-analysis-code-smell-alternative-classes-with-different-interfaces": "유사한 기능을 수행하는 클래스들이 서로 다른 인터페이스를 사용하는 경우.",
  "skillMonitor-analysis-code-smell-refused-bequest": "하위 클래스가 상위 클래스에서 상속받은 메서드나 필드를 사용하지 않는 경우.",
  "skillMonitor-analysis-code-smell-switch-statements": "switch문이나 if-else 블록이 반복적으로 사용되거나 지나치게 복잡한 경우.",
  "skillMonitor-analysis-code-smell-temporary-field": "클래스의 필드가 특정 상황에서만 사용되어 코드 가독성과 유지보수를 저해하는 경우.",
  "skillMonitor-analysis-code-smell-divergent-change": "하나의 클래스가 서로 다른 이유로 자주 변경되는 경우.",
  "skillMonitor-analysis-code-smell-parallel-inheritance-hierarchies": "한 클래스 계층이 다른 클래스 계층과 평행한 구조를 유지하며 의존성이 강한 경우.",
  "skillMonitor-analysis-code-smell-shotgun-surgery": "작은 변경이 프로젝트 내 여러 클래스에 퍼져서 수정해야 하는 경우.",
  "skillMonitor-analysis-code-smell-comments": "코드 자체로 이해되지 않아 주석이 과도하게 필요하거나, 주석으로만 의도를 알 수 있는 경우.",
  "skillMonitor-analysis-code-smell-duplicate-code": "동일한 코드가 여러 곳에 중복되어 있는 경우.",
  "skillMonitor-analysis-code-smell-data-class": "필드와 getter/setter 메서드만 포함되어 있는 데이터 전용 클래스.",
  "skillMonitor-analysis-code-smell-dead-code": "더 이상 사용되지 않는 코드가 프로젝트에 남아있는 경우.",
  "skillMonitor-analysis-code-smell-lazy-class": "클래스가 너무 적은 책임만 가지고 있어 존재 의미가 부족한 경우.",
  "skillMonitor-analysis-code-smell-speculative-generality": "미래에 필요할 가능성을 염두에 두고 작성된, 현재는 필요 없는 일반화된 코드.",
  "skillMonitor-analysis-code-smell-feature-envy": "메서드가 자신이 속한 클래스보다 다른 클래스의 데이터에 더 많은 관심을 가지는 경우.",
  "skillMonitor-analysis-code-smell-inappropriate-intimacy": "두 클래스가 지나치게 밀접하게 의존하여 서로의 내부에 깊숙이 접근하는 경우.",
  "skillMonitor-analysis-code-smell-incomplete-library-class": "사용하는 라이브러리 클래스가 필요한 기능을 제공하지 않아 불편함을 초래하는 경우.",
  "skillMonitor-analysis-code-smell-message-chains": "메서드 호출이 연속적으로 연결되어 지나치게 긴 체인 형태를 가지는 경우.",
  "skillMonitor-assessment-candidates-result": "응시자 결과",
  "skillMonitor-assessment-report-guide": "리포트 해석 가이드",
  "skillMonitor-assessment-summary-title": "평가 요약",
  "skillMonitor-track-summary-title-change": "트랙 요약",
  "skillMonitor-skill-summary-title": "스킬 요약",
  "skillMonitor-assessment-summary-candidates-rate": "완료율",
  "skillMonitor-assessment-summary-skill-rate": "스킬 확보율",
  "skillMonitor-assessment-summary-result": "평가 결과 요약",
  "skillMonitor-assessment-summary-track-table-title": "트랙별 설명",
  "skillMonitor-track-summary-result": "트랙 결과 요약",
  "skillMonitor-track-summary-score-info": "트랙 점수 정보",
  "skillMonitor-track-summary-min": "최저",
  "skillMonitor-track-summary-mid": "중간",
  "skillMonitor-track-summary-max": "최고",
  "skillMonitor-track-summary-highest": "가장 높은",
  "skillMonitor-track-summary-lowest": "가장 낮은",
  "skillMonitor-track-summary-score-highest-info": "평균 점수가 가장 높은 트랙입니다.",
  "skillMonitor-track-summary-score-lowest-info": "평균 점수가 가장 낮은 트랙입니다.",
  "skillMonitor-track-summary-high": "높음",
  "skillMonitor-track-summary-low": "낮음",
  "skillMonitor-track-summary-table-standard-deviation": "표준 편차",
  "skillMonitor-track-summary-table-average-time-taken": "평균 소요 시간",
  "skillMonitor-assessment-candidates-chart-track-score": "평가 응시자들의 트랙 점수 분포",
  "skillMonitor-all-candidates-based-info-top": "상위",
  "skillMonitor-all-candidates-based-info-bottom": "하위",
  "skillMonitor-assessment-candidates-chart-track-score-range": "점수 구간",
  "skillMonitor-assessment-candidates-chart-track-time-taken-range": "소요시간 (분) 구간",
  "skillMonitor-assessment-candidates-chart-track-skill-rate-range": "스킬 확보율 (%) 구간",
  "skillMonitor-assessment-candidates-chart-percentage": "평가 응시자 비율",
  "skillMonitor-assessment-candidates-chart-button": "구간별 응시자 보기",
  "skillMonitor-assessment-candidates-chart-track-time-taken": "평가 응시자들의 트랙 소요 시간 분포",
  "skillMonitor-track-summary-skill-acquisition-rate-and-time-taken-info": "트랙 스킬 확보율 및 소요 시간 정보",
  "skillMonitor-track-summary-skill-rate-highest-info": "평균 스킬 확보율이 가장 높은 트랙입니다.",
  "skillMonitor-track-summary-skill-rate-lowest-info": "평균 스킬 확보율이 가장 낮은 트랙입니다.",
  "skillMonitor-assessment-candidates-chart-track-skill-rate": "평가 응시자들의 트랙 스킬 확보율 분포",
  "skillMonitor-track-summary-skill-info": "트랙 스킬 정보",
  "skillMonitor-track-summary-skill-acquired": "획득",
  "skillMonitor-track-summary-skill-needs-Improvement": "보완 필요",
  "skillMonitor-track-summary-skill-not-acquired": "미획득",
  "skillMonitor-assessment-candidates-chart-track-skill-level": "평가 응시자들의 트랙 스킬 레벨 분포",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend": "스킬 레벨",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-acquired": "역량을 확보하고 있음",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-needs-Improvement": "개념에 대한 이해는 있으나, 현업에서의 적용 및 활용 역량은 보완이 필요함",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-not-acquired": "역량을 확보하고 있지 않음",
  "skillMonitor-assessment-summary-result-none-data": "아직 결과 요약이 없습니다.\n결과 요약은 평가 종료 후 생성됩니다.",
  "skillMonitor-candidate-report-unsubmitted-1": "응시자는 평가 항목 전반에 걸쳐 답안을 제출하지 않았습니다.\n이로 인해 각 역량의 확보 여부 및 세부 수준을 객관적으로 판단할 수 있는 근거가 확보되지 않아, 종합적인 수준 진단이 불가합니다.",
  "skillMonitor-candidate-report-unsubmitted-2": "본 평가에서 응시자가 제출한 답안이 없어 해당 역량을 평가할 수 없습니다.",
  "skillMonitor-sort-by": "정렬 기준",
  "skillMonitor-candidates-summary-title": "응시자 요약",
  "skillMonitor-candidates-summary-result": "응시자 결과 요약",
  "skillMonitor-score-based-info": "점수 기준",
  "skillMonitor-skill-acquisition-rate-based-info": "스킬 확보율 기준",
  "skillMonitor-candidates-Integrity-concerns-info": "무결성 우려 응시자",
  "skillMonitor-candidates-Integrity-reason": "사유",
  "skillMonitor-candidate-action-analysis-result": "행동 분석 결과",
  "skillMonitor-candidate-report": "응시자 리포트",
  "skillMonitor-assessment-summary-score-info": "평가 점수 정보",
  "skillMonitor-summary-table-assessment-average-score": "평가 응시자 평균 점수 대비",
  "skillMonitor-summary-table-assessment-average-none": "총 응시자 1명이므로\n평균 대비 데이터는 제공되지 않습니다.",
  "skillMonitor-assessment-candidates-chart-assessment-score": "평가 응시자들의 평가 점수 분포",
  "skillMonitor-assessment-candidates-chart-assessment-time-taken": "평가 응시자들의 평가 소요 시간 분포",
  "skillMonitor-assessment-summary-skill-acquisition-rate-and-time-taken-info": "평가 스킬 확보율 및 소요 시간 정보",
  "skillMonitor-summary-table-assessment-average-skill-rate": "평가 응시자 평균 스킬 확보율 대비",
  "skillMonitor-assessment-candidates-chart-assessment-skill-rate": "평가 응시자들의 평가 스킬 확보율 분포",
  "skillMonitor-assessment-submission-button": "제출물 보기",
  "skillMonitor-track-summary-score-highest-info-2": "점수가 가장 높은 트랙입니다.",
  "skillMonitor-track-summary-score-lowest-info-2": "점수가 가장 낮은 트랙입니다.",
  "skillMonitor-track-summary-skill-rate-highest-info-2": "스킬 확보율이 가장 높은 트랙입니다.",
  "skillMonitor-track-summary-skill-rate-lowest-info-2": "스킬 확보율이 가장 낮은 트랙입니다.",
  "skillMonitor-candidate-strength-button": "강점 보기",
  "skillMonitor-candidate-areas-for-improvement-button": "보완점 보기",
  "skillMonitor-candidate-strength-areas-for-improvement-button": "강점 및 보완점 보기",
  "skillMonitor-candidate-strength": "강점",
  "skillMonitor-candidate-areas-for-improvement": "보완점",
  "skillMonitor-candidate-sw-quality-analysis-result": "SW 품질 분석 결과",
  "skillMonitor-candidate-sw-quality-analysis-result-info": "SW 품질 분석 결과는 분석이 가능한 문제에 대해서만 제공됩니다.",
  "skillMonitor-candidate-sw-quality-analysis-result-count": "{total}개의 문제 중 {question}개의 문제",
  "skillMonitor-candidate-sw-quality-analysis-summary-result": "SW 품질 분석 결과 요약",
  "skillMonitor-candidate-sw-quality-analysis-recommendations-for-improvement": "개선 권장 사항",
  "skillMonitor-static-analysis-metrics-count": "{count}개의 지표",
  "skillMonitor-analysis-primary-file": "분석 대상 파일",
  "skillMonitor-analysis-pass": "통과",
  "skillMonitor-analysis-warning": "주의",
  "skillMonitor-analysis-fail": "실패",
  "skillMonitor-analysis-not-applicable": "계산되지 않음",
  "skillMonitor-candidate-action-analysis-info": "행동 분석 정보",
  "skillMonitor-candidates-Integrity-grade": "무결성 등급",
  "skillMonitor-candidates-grade": "등급",
  "skillMonitor-candidates-Integrity-grade-1": "부정행위 없음",
  "skillMonitor-candidates-Integrity-grade-1-description": "평가 도중 의심스러운 행동이나 부정행위 기록 없이, 응시자는 모든 규정을 철저히 준수했습니다.",
  "skillMonitor-candidates-Integrity-grade-2": "경미한 의심 행동",
  "skillMonitor-candidates-Integrity-grade-2-description": "평가 도중 약간의 의심스러운 행동이 있었으나, 명백한 부정행위로 단정할 수 없으며, 전반적으로 규정을 잘 준수했습니다.",
  "skillMonitor-candidates-Integrity-grade-3": "의심스러운 행동",
  "skillMonitor-candidates-Integrity-grade-3-description": "평가 도중 부정행위로 의심될 만한 행동이 확인되었으며, 추가적인 수동 검증이 필요합니다.",
  "skillMonitor-candidates-Integrity-grade-4": "명백한 부정행위 시도",
  "skillMonitor-candidates-Integrity-grade-4-description": "평가 도중 부정행위를 시도한 명확한 증거가 확인되었으나, 성공적으로 이루어지지는 않았습니다.",
  "skillMonitor-candidates-Integrity-grade-5": "부정행위 확인",
  "skillMonitor-candidates-Integrity-grade-5-description": "평가 도중 명백한 부정행위가 발생했으며, 그로 인해 테스트 결과의 신뢰성이 크게 손상되었습니다.",
  "skillMonitor-report-candidate-action-analysis-clean-default-reason": "본 평가에서 부정행위가 확인되지 않았습니다.",
  "skillMonitor-candidate-action": "응시자 행동 내역",
  "skillMonitor-candidate-action-count": "건",
  "skillMonitor-candidate-video-delete": "영상이 삭제되었습니다.",
  "skillMonitor-candidate-video-no-save": "영상이 저장되지 않았습니다.",
  "skillMonitor-candidate-recommended-for-review-label": "검토 권장",
  "skillMonitor-candidate-video-recording-duration-information": "녹화 시간 정보",
  "skillMonitor-candidate-video-start": "시작",
  "skillMonitor-candidate-video-end": "종료",
  "skillMonitor-candidate-video-current": "현재",
  "skillMonitor-candidate-video-no-face-voice-recording": "얼굴/음성 녹화 공백",
  "skillMonitor-candidate-video-no-screen-recording": "화면 녹화 공백",
  "skillMonitor-candidate-video-no-description": "녹화 공백은 응시자 이탈, 시스템 문제 등으로 인해 녹화 데이터가 존재하지 않는 구간입니다.",
  "skillMonitor-candidate-video-playback-speed": "재생 속도",
  "skillMonitor-candidate-video-view-full-screen": "전체 화면 보기",
  "skillMonitor-candidate-video-screen-recording": "화면 녹화",
  "skillMonitor-assessment-report-get-by-email": "평가 리포트 이메일로 받기",
  "skillMonitor-candidate-report-get-by-email": "응시자 리포트 이메일로 받기",
  "skillMonitor-all-candidate-report-get-by-email": "모든 응시자 리포트 이메일로 받기",
  "skillMonitor-assessment-send-report-title": "리포트를 받을 이메일을 입력해주세요",
  "skillMonitor-assessment-send-report-description": "리포트는 입력하신 이메일로 {pdf} 형식으로 발송되며 다소 시간이 소요될 수 있습니다.",
  "skillMonitor-assessment-send-report-description-pdf": "PDF 파일",
  "skillMonitor-assessment-send-report-description-zip": "ZIP 파일",
  "skillMonitor-assessment-send-report-button": "리포트 발송",
  "skillMonitor-assessment-send-report-success": "리포트 발송 요청이 완료되었습니다.",
  "skillMonitor-assessment-send-report-fail": "리포트 발송 요청을 완료할 수 없습니다. \n다시 시도해주세요.",
  "home-event-title": "코드프레소 이벤트",
  "home-event-count": "개의 이벤트",
  "home-event-type-Webinar": "웨비나",
  "home-event-type-Conference": "컨퍼런스",
  "home-event-type-Seminar": "세미나",
  "home-event-type-Workshop": "워크샵",
  "home-event-type-NetworkingEvent": "네트워킹 이벤트",
  "home-event-type-Exhibition": "박람회",
  "home-event-type-LaunchEvent": "런칭 이벤트",
  "home-event-type-Learnathon": "러너톤",
  "home-event-engage-Online": "온라인",
  "home-event-engage-Offline": "오프라인",
  "home-event-engage-OnOffline": "온/오프라인",
  "home-event-none": "아직 등록된 이벤트가 없습니다.",
  "home-event-all": "전체 이벤트",
  "home-event-info": "이벤트 정보",
  "home-event-info-date": "이벤트 일시",
  "home-event-info-period": "등록 기간",
  "home-event-info-location": "장소",
  "home-event-info-language": "언어",
  "common-share": "공유",
  "home-event-register": "등록",
  "home-event-speakers": "발표자",
  "home-blog-title": "코드프레소 블로그",
  "home-blog-count": "개의 글",
  "home-blog-none": "아직 등록된 글이 없습니다.",
  "home-blog-all-post": "전체 글",
  "home-blog-author": "저자",
  "home-blog-about-codepresso": "코드프레소 소개",
  "home-blog-about-codepresso-description": "코드프레소는 모든 조직이 디지털 역량을 정량화하여 기술 기반의 디지털 인재 관리를 강화할 수 있도록 HR SaaS를 제공합니다. 코드프레소를 통해 조직은 디지털 인재를 손쉽게 평가, 진단, 채용하고 맞춤형 교육·훈련 콘텐츠를 제공할 수 있습니다. 이 과정에서 수집된 모든 역량 데이터는 조직이 데이터 기반 의사 결정을 내릴 수 있도록 지원합니다.",
  "home-blog-about-codepresso-learn-more": "코드프레소에 대해 더 알아보기",
  "home-news-title": "코드프레소 뉴스",
  "home-news-count": "건의 뉴스",
  "home-news-none": "아직 뉴스가 없습니다.",
  "home-news-topic": "뉴스",
  "dashboard-my-profile": "프로필 보기",
  "account-profile": "프로필",
  "profile-private-info": "비공개 정보입니다.",
  "profile-skill-none-data": "아직 작성된 스킬이 없습니다.",
  "profile-bios-none-data": "아직 작성된 자기소개가 없습니다.",
  "profile-activity-history-none-data": "아직 활동 내역이 없습니다.",
  "profile-work-experience-none-data": "아직 작성된 경력이 없습니다.",
  "profile-education-none-data": "아직 작성된 학력이 없습니다.",
  "profile-edit": "수정",
  "profile-image-upload-fail": "이미지를 업로드할 수 없습니다. \n파일이 JPG, JPEG, PNG 또는 BMP인지 확인해주세요.",
  "profile-change-success": "프로필 변경 사항이 저장되었습니다.",
  "profile-change-fail": "프로필 변경 사항을 저장할 수 없습니다. \n다시 시도해주세요.",
  "profile-private": "비공개",
  "profile-public": "공개",
  "profile-private-change-success": "프로필 정보가 비공개로 전환되었습니다.",
  "profile-public-change-success": "프로필 정보가 공개로 전환되었습니다.",
  "profile-job-offer": "채용 제안",
  "profile-job-offer-info": "이 설정을 활성화하면 채용 제안을 받을 수 있습니다.",
  "profile-add": "추가",
  "profile-headline": "헤드라인",
  "profile-headline-placeholder": "헤드라인을 입력해주세요.",
  "profile-headline-error": "헤드라인은 200자 이내여야 합니다.",
  "profile-personal-info-title": "개인 정보",
  "profile-gender": "성별",
  "profile-gender-drop-item-default": "성별을 선택해주세요.",
  "profile-gender-drop-item-male": "남성",
  "profile-gender-drop-item-female": "여성",
  "profile-gender-drop-item-other": "기타",
  "profile-gender-drop-item-not-say": "선택 안 함",
  "profile-phone-number": "휴대폰 번호",
  "profile-phone-number-placeholder": "휴대폰 번호를 입력해주세요.",
  "profile-phone-number-error": "휴대폰 번호는 25자 이내여야 합니다.",
  "profile-links": "링크",
  "profile-links-error-linkedIn": "유효한 링크드인 URL을 입력해야 합니다.",
  "profile-links-error-gitHub": "유효한 깃허브 URL을 입력해야 합니다.",
  "profile-links-add": "링크 추가",
  "profile-links-remove": "링크를 제거하시겠습니까?",
  "profile-links-remove-success": "링크가 성공적으로 제거되었습니다.",
  "profile-skills": "스킬",
  "profile-skills-search-placeholder": "스킬 검색",
  "profile-skills-search-none": "{skill}을(를) 찾을 수 없습니까? 스킬을 추가하시겠습니까?",
  "profile-skills-remove": "스킬을 제거하시겠습니까?",
  "profile-skills-remove-success": "스킬이 성공적으로 제거되었습니다.",
  "profile-about-me": "자기소개",
  "profile-title": "제목",
  "profile-title-placeholder": "제목을 입력해주세요.",
  "profile-title-error": "제목은 50자 이내여야 합니다.",
  "profile-content": "내용",
  "profile-content-placeholder": "내용을 입력해주세요.",
  "profile-content-error": "내용은 1500자 이내여야 합니다.",
  "profile-about-me-delete": "자기소개를 삭제하시겠습니까?",
  "profile-about-me-delete-success": "자기소개가 성공적으로 삭제되었습니다.",
  "profile-about-me-delete-fail": "자기소개를 삭제할 수 없습니다.\n다시 시도해주세요.",
  "profile-activity-history": "활동 내역",
  "profile-view-more": "더보기",
  "profile-view-less": "간략히 보기",
  "profile-work-experience": "경력",
  "profile-work-experience-company-name": "회사명",
  "profile-work-experience-company-name-placeholder": "회사명을 입력해주세요.",
  "profile-work-experience-company-name-error": "회사명은 50자 이내여야 합니다.",
  "profile-work-experience-job-title": "직책",
  "profile-work-experience-job-title-placeholder": "직책을 입력해주세요.",
  "profile-work-experience-job-title-error": "직책은 50자 이내여야 합니다.",
  "profile-work-experience-location": "근무지",
  "profile-work-experience-location-placeholder": "근무지를 입력해주세요.",
  "profile-work-experience-location-error": "근무지는 150자 이내여야 합니다.",
  "profile-work-experience-period": "재직중",
  "common-start-date": "시작일",
  "common-month": "월",
  "common-year": "연도",
  "common-end-date": "종료일",
  "profile-period-error": "종료일은 시작일보다 빠를 수 없습니다.",
  "profile-work-experience-description-placeholder": "설명을 입력해주세요.",
  "profile-work-experience-description-error": "설명은 1500자 이내여야 합니다.",
  "profile-work-experience-entry-delete-title": "경력을 삭제하시겠습니까?",
  "profile-work-experience-entry-delete-success": "경력이 성공적으로 삭제되었습니다.",
  "profile-work-experience-entry-delete-fail": "경력을 삭제할 수 없습니다.\n다시 시도해주세요.",
  "profile-present": "현재",
  "profile-education": "학력",
  "profile-education-school-name": "학교명",
  "profile-education-school-name-placeholder": "학교명을 입력해주세요.",
  "profile-education-school-name-error": "학교명은 50자 이내여야 합니다.",
  "profile-education-degree": "학위",
  "profile-education-degree-placeholder": "학위를 입력해주세요.",
  "profile-education-degree-error": "학위는 50자 이내여야 합니다.",
  "profile-education-major": "전공",
  "profile-education-major-placeholder": "전공을 입력해주세요.",
  "profile-education-major-error": "전공은 50자 이내여야 합니다.",
  "profile-education-current-studying": "재학중",
  "profile-education-delete-title": "학력을 삭제하시겠습니까?",
  "profile-education-delete-success": "학력이 성공적으로 삭제되었습니다.",
  "profile-education-delete-fail": "학력을 삭제할 수 없습니다.\n다시 시도해주세요.",
  "profile-access-limit": "프로필에 접근할 수 없습니다",
  "profile-access-limit-description": "탈퇴한 회원의 프로필은 확인할 수 없습니다.",
  "advance-practice-assessment": "연습 평가",
  "learning-assessment-goal": "연습 평가 목적",
  "learning-assessment-goal-description": "특정 트랙 레벨에 대한 경험이 얼마나 되는지 알고 싶습니다.",
  "learning-assessment-evaluate": "문제 구성",
  "learning-assessment-evaluate-description": "연습 평가는 실습 및 객관식 문제로 이루어져 있습니다.",
  "learning-assessment-how-to-complete": "완료 방법",
  "learning-assessment-how-to-complete-description": "연습 평가를 통과하려면 합격 점수를 받아야 합니다.",
  "common-retake": "재응시",
  "learning-progress": "진행 상황",
  "learning-leave-warning-title": "평가 화면에서 벗어나시겠습니까?",
  "learning-leave-warning-description": "제출한 답안이 저장되지 않을 수 있습니다.",
  "learning-leave": "나가기",
  "learning-finished-question": "답안이 제출되었습니다.",
  "learning-assessment-date": "평가일",
  "learning-completed-banner": "평가를 완료했습니다",
  "learning-completed-success-description": "합격 점수에 도달하여 평가를 통과했습니다.\n이제 새로운 레벨의 연습 평가를 시작하거나 완료된 레벨의 연습 평가 결과를 다시 검토할 수 있습니다.",
  "learning-completed-fail-description": "합격 점수에 도달하지 못했습니다.\n재응시하여 평가를 완료해주세요.",
  "skillCertify-view-result": "결과 보기",
  "pricing-menu": "가격",
  "pricing-title": "기술 역량 평가를 위한 플랜",
  "pricing-content": "목적에 맞는 플랜을 선택하세요",
  "pricing-monthly": "월간",
  "pricing-annual": "연간",
  "pricing-off": "{percent}% 할인",
  "pricing-basic": "베이직",
  "pricing-pro": "프로",
  "pricing-enterprise": "엔터프라이즈",
  "pricing-recommend": "추천",
  "pricing-year": "연",
  "pricing-custom-pricing": "사용자 지정 가격",
  "pricing-basic-report": "기본형 리포트",
  "pricing-basic-skill-report": "기본형 역량 리포트",
  "pricing-report-language-single": "언어 1개",
  "pricing-ai-assessment-recommendation-times": "AI 맞춤 평가 추천 월 {count}회",
  "pricing-report-language-unlimited": "언어 제한 없음",
  "pricing-administrator-account-plural": "조직 관리자 무제한",
  "pricing-advanced-report": "고급형 리포트",
  "pricing-advanced-skill-report": "고급형 역량 리포트",
  "pricing-all-skill-assessments": "모든 역량 평가",
  "pricing-custom-questions": "평가 문항 맞춤 설계",
  "pricing-account-manager": "전담 매니저",
  "pricing-ai-assessment-recommendation-unlimited": "AI 맞춤 평가 추천 무제한",
  "pricing-get-started": "시작하기",
  "pricing-coming-soon": "출시 예정",
  "pricing-current-plan": "현재 플랜",
  "pricing-upgrade": "업그레이드",
  "pricing-downgrade": "다운그레이드",
  "pricing-compare-features-by-plan": "플랜별 기능 비교",
  "pricing-feature": "기능",
  "pricing-monthly-basic-assessment-invitation-credits": "월 기본 평가 초대 크레딧 (이월 불가)",
  "pricing-contract-terms": "계약 조건",
  "pricing-purchase-additional-credits": "평가 초대 크레딧 추가 구매",
  "pricing-per-credit": "크레딧 당 {price}",
  "pricing-assessment-features": "평가 기능",
  "pricing-create-basic-assessment": "기본 평가 생성",
  "pricing-advanced-assessment": "프로젝트 역량 평가",
  "pricing-core-assessment": "실무 역량 평가",
  "pricing-ai-agent-assessment": "AI 활용 역량 평가",
  "pricing-core-assessment-description": "Core는 디지털 IT 분야의 핵심 기술 역량을 측정하는 실무 중심 평가로, 현업 시나리오를 반영한 문항과 실습 기반 평가를 통해 개인의 기술 이해도와 실무 활용 역량을 진단하는 데 활용할 수 있습니다.",
  "pricing-advanced-assessment-description": "E2E는 실무 환경에서 현업과 유사한 프로젝트 과제를 수행하며, 설계부터 구현까지 개발자의 실무 역량을 종합적으로 검증하는 데 활용할 수 있습니다.",
  "pricing-ai-agent-assessment-description": "AI Fluent는 실무 프로젝트를 기반으로 AI 활용 역량부터 개인의 AI 거버넌스 역량까지 종합적으로 검증하며, 조직의 AI 기반 개발 문화 점검과 역량 강화 방향성 도출에 활용할 수 있습니다.",
  "pricing-core-assessment-filter-description": "Core는",
  "pricing-core-assessment-filter-description-1": "디지털 IT 분야의 핵심 기술 역량을 측정하는 실무 중심 평가로, 현업 시나리오를 반영한 문항과 실습 기반 평가를 통해 개인의 기술 이해도와 실무 활용 역량을 진단하는 데 활용할 수 있습니다.",
  "pricing-advanced-assessment-filter-description": "E2E는",
  "pricing-advanced-assessment-filter-description-1": "실무 환경에서 현업과 유사한 프로젝트 과제를 수행하며, 설계부터 구현까지 개발자의 실무 역량을 종합적으로 검증하는 데 활용할 수 있습니다.",
  "pricing-ai-agent-assessment-filter-description": "AI Fluent는",
  "pricing-ai-agent-assessment-filter-description-2": "실무 프로젝트를 기반으로 AI 활용 역량부터 개인의 AI 거버넌스 역량까지 종합적으로 검증하며, 조직의 AI 기반 개발 문화 점검과 역량 강화 방향성 도출에 활용할 수 있습니다.",
  "pricing-report-language": "역량 리포트 언어",
  "pricing-report-language-count-1": "1개",
  "pricing-report-language-count-2": "제한 없음",
  "pricing-certificate-provided": "역량 인증서",
  "pricing-ai-features": "AI 기능",
  "pricing-report": "역량 리포트",
  "pricing-ai-assessment-recommendation": "AI 맞춤 평가 추천",
  "pricing-times-a-month": "월 {count}회",
  "pricing-management-and-support": "관리 및 지원",
  "pricing-person": "1명",
  "pricing-administrator": "조직 관리자",
  "pricing-ats-integration": "채용 관리 시스템(ATS)",
  "pricing-to-be-added": "추가 예정",
  "pricing-basic-ats-provided": "기본 ATS 제공",
  "pricing-custom-integration": "전용 ATS 구축",
  "pricing-support": "지원",
  "pricing-faq": "자주 묻는 질문",
  "pricing-faq-question-1": "어떤 플랜을 선택해야 하나요?",
  "pricing-faq-question-1-answer-1": "평가 운영 목적과 필요한 기능 수준에 따라 플랜을 선택하실 수 있습니다.",
  "pricing-faq-question-1-answer-2": "플랜",
  "pricing-faq-question-1-answer-3": "추천 대상",
  "pricing-faq-question-1-answer-4": "기본 감독과 기본형 역량 리포트로 기술 역량 평가를 시작하려는 조직",
  "pricing-faq-question-1-answer-5": "강화 감독, 프로젝트 역량 평가 등 고도화 평가 기능이 필요한 조직",
  "pricing-faq-question-1-answer-6": "모든 역량 평가, 전용 ATS 구축, 전담 매니저 지원이 필요한 조직",
  "pricing-faq-question-2": "평가 초대 크레딧은 무엇인가요?",
  "pricing-faq-question-2-answer-1": "평가 초대 크레딧은 응시자를 평가에 초대할 때 사용되는 단위입니다.",
  "pricing-faq-question-2-answer-2": "평가를 운영하려면 응시자 수와 평가 구성에 따라 평가 초대 크레딧이 필요합니다.",
  "pricing-faq-question-3": "응시자 1명 초대 시 몇 개의 크레딧이 사용되나요?",
  "pricing-faq-question-3-answer-1": "기본 평가 초대 기준, 응시자 1명당 평가 초대 크레딧 1개가 사용됩니다.",
  "pricing-faq-question-3-answer-2": "다만 프로젝트 역량 평가와 같은 고도화 평가 기능을 포함하는 경우, 평가 구성에 따라 추가 크레딧이 사용될 수 있습니다.",
  "pricing-faq-question-4": "평가 초대 크레딧은 언제 사용되나요?",
  "pricing-faq-question-4-answer-1": "응시자를 초대할 때, 초대하는 응시자 수와 평가 구성에 따라 평가 초대 크레딧이 사용됩니다.",
  "pricing-faq-question-4-answer-2": "응시자가 평가를 시작하기 전에 응시자 목록에서 삭제하면 해당 응시자에게 사용된 평가 초대 크레딧이 취소됩니다.",
  "pricing-faq-question-4-answer-3": "단, 응시자가 평가를 시작한 이후에는 평가 초대 크레딧 사용을 취소할 수 없습니다.",
  "pricing-faq-question-5": "월 기본 평가 초대 크레딧을 모두 사용하면 어떻게 되나요?",
  "pricing-faq-question-5-answer-1": "월 기본 평가 초대 크레딧을 모두 사용한 경우, 크레딧을 충전하여 사용할 수 있습니다.",
  "pricing-faq-question-5-answer-2": "크레딧 충전은 조직 최고 관리자만 진행 가능합니다.",
  "pricing-faq-question-5-answer-3": "충전 크레딧은 별도의 유효기간이 없으나, 구독 중인 상태에서만 충전 및 사용할 수 있습니다.",
  "pricing-faq-question-5-answer-4": "단, 엔터프라이즈 플랜은 별도 계약 조건에 따라 운영되므로 크레딧 충전이 필요한 경우 별도 문의가 필요합니다.",
  "pricing-faq-question-6": "카드 만료 등으로 결제에 실패하면 어떻게 되나요?",
  "pricing-faq-question-6-answer-1": "결제에 실패하면 조직 최고 관리자 이메일로 안내 메일이 발송됩니다.",
  "pricing-faq-question-6-answer-2": "결제 실패 후 최대 3회까지 자동 결제 재시도가 이루어질 수 있습니다.",
  "pricing-faq-question-6-answer-3": "이후에도 결제에 실패하면 자동 결제 재시도가 중단되며, 구독이 종료됩니다.",
  "pricing-faq-question-7": "구독을 해지하면 어떻게 되나요?",
  "pricing-faq-question-7-answer-1": "구독을 해지하면 다음 결제일부터 자동 결제가 중단됩니다.",
  "pricing-faq-question-7-answer-2": "이미 결제된 구독 기간이 남아 있는 경우, 해당 기간 동안에는 기존 플랜을 계속 사용할 수 있습니다.",
  "pricing-faq-question-7-answer-3": "구독 기간이 종료되면 보유 중인 충전 크레딧도 사용할 수 없으며, 구독을 재시작하면 다시 사용할 수 있습니다.",
  "pricing-faq-question-8": "환불이 가능한가요?",
  "pricing-faq-question-8-answer-1": "구독 플랜과 충전 크레딧에 대한 결제 금액은 원칙적으로 환불되지 않습니다.",
  "pricing-faq-question-8-answer-2": "다만 회사의 귀책사유 또는 관련 법률상 환불이 필요한 예외적인 상황에서는 환불이 검토될 수 있습니다.",
  "pricing-faq-question-8-answer-3": "자세한 사항은 {link}을 참고해주세요.",
  "pricing-faq-question-9": "환불 금액은 어떤 기준으로 산정되며, 환불은 어떻게 요청하나요?",
  "pricing-faq-question-9-answer-1": "예외적으로 환불이 승인되는 경우, 환불 금액은 실제 결제 금액(세금 포함)을 기준으로 산정됩니다.",
  "pricing-faq-question-9-answer-2": "쿠폰이나 프로모션을 통해 할인된 금액은 환불 금액에 포함되지 않습니다.",
  "pricing-faq-question-9-answer-3": "환불 검토가 필요한 경우, 하단의 문의하기 아이콘(채널톡) 또는 {link1}로 요청하실 수 있으며, 검토 후 환불 가능 여부와 최종 환불 금액을 안내드립니다.",
  "pricing-info-1-title": "구독 플랜은 조직 계정만 이용할 수 있습니다",
  "pricing-info-2-title": "구독 플랜을 이용하려면 먼저 조직을 생성해야 합니다",
  "pricing-info-2-description": "조직 설정으로 이동",
  "pricing-info-3-title": "구독 플랜 결제는 조직 최고 관리자만 진행할 수 있습니다",
  "payment-payment-information": "결제 정보",
  "payment-organization-information": "조직 정보",
  "payment-payment-method": "결제 수단",
  "payment-cardholder-name": "카드 소유자명",
  "payment-card-number": "카드 번호",
  "payment-expiration-date": "만료 날짜",
  "payment-security-code": "보안 코드",
  "payment-product-price": "상품 금액",
  "payment-coupon-discount": "쿠폰 할인",
  "payment-select-coupon": "쿠폰 선택",
  "payment-coupon-discount-amount": "쿠폰 할인 금액",
  "payment-cancel-coupon": "쿠폰 적용 취소",
  "payment-estimated-payment-amount": "예상 결제 금액",
  "payment-tax-description": "세금은 결제 단계에서 계산됩니다.",
  "payment-agree-all-check": "전체 동의",
  "payment-agree-required": "필수",
  "payment-agree-check-1": "{policy} 및 {term} 동의",
  "payment-agree-check-2": "구독 자동 갱신 및 결제 수단 저장·청구 동의",
  "payment-subscribe": "구독하기",
  "payment-subscribe-processing": "처리중입니다",
  "payment-subscribe-info-1": "결제 주기에 따라 자동 결제됩니다.",
  "payment-subscribe-info-2": "결제일에 해당하는 날이 없는 달의 경우(예: 31일), 그달의 말일에 결제가 이루어집니다.",
  "payment-cardholder-name-error-1": "카드 소유자명을 입력해주세요.",
  "payment-cardholder-name-error-2": "카드 소유자명은 1~20자 사이여야 합니다.",
  "payment-card-number-error-1": "카드 번호를 입력해주세요.",
  "payment-card-number-error-2": "카드 번호를 다시 확인해주세요.",
  "payment-expiration-date-error-1": "만료 날짜를 입력해주세요.",
  "payment-expiration-date-error-2": "만료 날짜를 다시 확인해주세요.",
  "payment-security-code-error-1": "보안 코드를 입력해주세요.",
  "payment-security-code-error-2": "보안 코드를 다시 확인해주세요.",
  "payment-coupon": "쿠폰",
  "payment-my-coupons": "내 쿠폰",
  "payment-annual-billing-only": "연간 결제 전용",
  "payment-monthly-subscription-only": "월간 결제 전용",
  "payment-first-purchase-only": "첫 결제 전용",
  "payment-benefits": "혜택",
  "payment-validity-period": "유효기간",
  "payment-days-left": "00일 남음",
  "payment-coupon-applied-success": "쿠폰이 적용되었습니다.",
  "payment-coupon-applied-fail": "쿠폰을 적용할 수 없습니다.\n다시 시도해주세요.",
  "payment-register-coupon": "쿠폰 등록",
  "payment-coupon-code": "쿠폰 번호",
  "payment-coupon-code-placeholder": "쿠폰 번호를 입력해주세요.",
  "payment-coupon-code-error": "유효하지 않은 쿠폰 번호입니다.",
  "payment-coupon-code-success": "쿠폰이 등록되었습니다.",
  "payment-coupon-code-fail": "쿠폰을 등록할 수 없습니다.\n다시 시도해주세요.",
  "payment-agree-required-error": "필수 항목에 동의해주세요.",
  "payment-error-title": "결제에 실패했습니다",
  "payment-error-contents": "입력하신 카드 정보를 확인하고 다시 시도해주세요.\n계속 실패하는 경우, 다른 카드를 사용하거나 카드사에 문의해주세요.\n문제가 지속되는 경우, {contact} 메뉴를 통해 문의해주세요.",
  "payment-error-contents-2": "다시 시도해주세요.\n계속 실패하는 경우, 다른 카드를 사용하거나 카드사에 문의해주세요.\n문제가 지속되는 경우, {contact} 메뉴를 통해 문의해주세요.",
  "payment-payment-method-none": "아직 등록된 결제 수단이 없습니다.",
  "payment-payment-method-register": "결제 수단 등록하기",
  "payment-payment-method-register-success": "결제 수단 등록이 완료되었습니다.",
  "payment-payment-method-register-fail-title": "결제 수단 등록에 실패했습니다",
  "payment-payment-method-register-fail-contents": "카드 정보를 확인하고 다시 시도해주세요.\n계속 실패하는 경우, 다른 카드를 사용하거나 카드사에 문의해주세요.\n문제가 지속되는 경우, {contact} 메뉴를 통해 문의해주세요.",
  "payment-payment-method-change-fail-title": "결제 수단 변경에 실패했습니다",
  "payment-complete-title": "결제 완료",
  "payment-complete-payment-history": "결제 내역",
  "payment-complete-payment-date": "결제일",
  "payment-complete-payment-amount": "결제 금액",
  "payment-complete-view-invoice": "청구서 보기",
  "payment-complete-next-billing-date": "다음 결제일",
  "payment-complete-description": "자세한 정보는 {payment}에서 확인해주세요.",
  "payment-complete-button": "구독 관리로 이동",
  "learning-away-with-out-title": "답안을 제출하지 않고 이동하시겠습니까?",
  "learning-away-with-out-description": "이동하기 전에 답안을 제출하여 저장하는 것을 권장합니다.\n제출 후에도 추가 변경 사항이 있다면 다시 제출하실 수 있습니다.",
  "learning-away-with-out-leave": "제출하지 않고 이동",
  "learning-away-with-out-stay": "머무르기",
  "skillCertify-locale-change-away-with-out-title": "답안을 저장하지 않고 언어를 변경하시겠습니까?",
  "skillCertify-locale-change-away-with-out-description": "언어를 변경하기 전에 답안을 제출하여 저장하는 것을 권장합니다.\n제출 후에도 추가 변경 사항이 있다면 다시 제출하실 수 있습니다.",
  "skillCertify-locale-change-away-with-out": "저장하지 않고 언어 변경",
  "terms-agree-title": "",
  "terms-agree-check-1": "",
  "terms-agree-check-2": "",
  "terms-agree-check-3": "",
  "skillCertify-not-participated": "",
  "skillCertify-no-show": "",
  "skillCertify-candidate-no-show-date": "",
  "skillCertify-proctoring-program-currently-running-title": "",
  "skillCertify-proctoring-program-currently-running-description": "",
  "skillCertify-close-proctoring-program-title": "",
  "skillCertify-close-proctoring-program-description": "",
  "skillCertify-close-proctoring-program-button": "",
  "skillCertify-proctoring-face-voice-recording-set-up-camera-no-use": "",
  "skillCertify-proctoring-face-voice-recording-set-up-camera-check-required": "",
  "skillCertify-proctoring-face-voice-recording-set-up-microphone-check-required": "",
  "skillCertify-assessment-completed-close-proctoring-program": "",
  "skillMonitor-track-summary-table-all-average-score": "",
  "skillMonitor-all-candidates-based-info": "",
  "skillMonitor-all-candidates-based-info-median": "",
  "skillMonitor-track-summary-table-all-average-skill-rate": "",
  "skillMonitor-candidate-sw-quality-analysis-info": "",
  "skillMonitor-candidate-code-quality-summary-result": "",
  "skillMonitor-candidate-code-quality-grade": "",
  "skillMonitor-candidate-code-quality-details": "",
  "skillMonitor-candidate-code-button": "",
  "skillMonitor-static-analysis-metrics": "",
  "skillMonitor-static-analysis": "",
  "skillMonitor-analysis-severity-medium": "",
  "skillMonitor-candidate-architecture-quality-summary-result": "",
  "skillMonitor-candidate-architecture-quality-grade": "",
  "skillMonitor-candidate-architecture-quality-details": "",
  "user-grades-type-chief-admin": "",
  "skillCertify-device-block-title": "PC 환경에서만 응시할 수 있습니다",
  "skillCertify-device-block-description": "PC로 접속 후 다시 시도해주세요.\n도움이 필요한 경우, 채널톡을 통해 문의해주세요.",
  "skillCertify-environment-check-start-button": "응시 환경 점검 시작",
  "skillCertify-environment-check-title": "응시 환경을 점검해주세요",
  "skillCertify-environment-check-description": "평가 시작 전 카메라, 마이크, 화면 녹화 기능이 정상적으로 되는지 확인해야 합니다.\n평가 시간은 점검을 완료하고 평가를 시작한 후부터 흐릅니다.",
  "skillCertify-environment-check-result-title": "점검 결과",
  "skillCertify-environment-check-status-checking": "확인중...",
  "skillCertify-environment-check-status-ok": "정상",
  "skillCertify-environment-check-status-failed": "확인 필요",
  "skillCertify-environment-check-has-failed-item": "정상적으로 확인되지 않은 항목이 있습니다.",
  "skillCertify-environment-check-help-button": "해결 방법 보기",
  "skillCertify-environment-check-help-title": "해결 방법",
  "skillCertify-environment-check-help-camera-microphone": "카메라/마이크",
  "skillCertify-environment-check-help-detail-guide": "자세한 해결 방법은 도움말 확인",
  "skillCertify-environment-check-contact-channel-talk": "도움이 필요한 경우, 채널톡을 통해 문의해주세요.",
  "skillCertify-environment-check-screen-share-guide-title": "화면 공유 기능을 점검해주세요",
  "skillCertify-environment-check-screen-share-guide-description": "평가 시작 전 화면 공유 기능이 정상적으로 되는지 확인해야 합니다.\n점검 시 **전체 화면**을 공유해주세요.\n평가 시간은 점검을 완료하고 평가를 시작한 후부터 흐릅니다.",
  "skillCertify-environment-check-screen-share-button": "화면 공유 기능 점검하기",
  "skillCertify-environment-check-screen-share-complete-title": "화면 공유 기능 점검이 완료되었습니다",
  "skillCertify-environment-check-screen-share-complete-description": "평가를 시작하려면 아래 버튼을 클릭해주세요.",
  "skillCertify-environment-check-full-screen-error": "화면 공유 기능을 점검하려면 **전체 화면**을 공유해야 합니다.",
  "skillCertify-environment-check-cancelled-toast": "점검을 완료해야 평가를 시작할 수 있습니다.",
  "skillCertify-environment-check-screen-share-permission-required": "화면 공유 권한이 필요합니다\n아래 내용을 확인해주세요",
  "skillCertify-environment-check-item-screen-recording": "화면 녹화",
  "skillCertify-environment-check-resolve-issue": "응시 환경 문제를 해결해주세요",
  "skillCertify-environment-check-help-camera": "카메라 권한 또는 연결 상태를 확인해주세요.",
  "skillCertify-environment-check-help-microphone": "마이크 권한 또는 연결 상태를 확인해주세요.",
  "skillCertify-environment-check-help-link-button": "도움말 보기"
};